// source: artifact/artifact.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var chatcontext_chatcontext_pb = require('../chatcontext/chatcontext_pb.js');
goog.object.extend(proto, chatcontext_chatcontext_pb);
var auditbotapi_auditbotapi_pb = require('../auditbotapi/auditbotapi_pb.js');
goog.object.extend(proto, auditbotapi_auditbotapi_pb);
goog.exportSymbol('proto.artifact.Artifact', null, global);
goog.exportSymbol('proto.artifact.Artifact.ArtifactDataCase', null, global);
goog.exportSymbol('proto.artifact.ArtifactType', null, global);
goog.exportSymbol('proto.artifact.AttachedArtifact', null, global);
goog.exportSymbol('proto.artifact.AttachedArtifact.ArtifactDataCase', null, global);
goog.exportSymbol('proto.artifact.Chart', null, global);
goog.exportSymbol('proto.artifact.Control', null, global);
goog.exportSymbol('proto.artifact.ControlsArtifact', null, global);
goog.exportSymbol('proto.artifact.CostEstimateArtifact', null, global);
goog.exportSymbol('proto.artifact.CrossReferenceJoinInfo', null, global);
goog.exportSymbol('proto.artifact.CrossReferencedDataArtifact', null, global);
goog.exportSymbol('proto.artifact.FilteredEvidenceArtifact', null, global);
goog.exportSymbol('proto.artifact.FrameworkDoc', null, global);
goog.exportSymbol('proto.artifact.FrameworkDocArtifact', null, global);
goog.exportSymbol('proto.artifact.FrameworkQuestionnaireArtifact', null, global);
goog.exportSymbol('proto.artifact.FrameworkSection', null, global);
goog.exportSymbol('proto.artifact.FrameworkSectionArtifact', null, global);
goog.exportSymbol('proto.artifact.GapType', null, global);
goog.exportSymbol('proto.artifact.MimeArtifact', null, global);
goog.exportSymbol('proto.artifact.OeControlGap', null, global);
goog.exportSymbol('proto.artifact.OeControlResultsArtifact', null, global);
goog.exportSymbol('proto.artifact.OeControlTestCitation', null, global);
goog.exportSymbol('proto.artifact.OeControlTestCitationType', null, global);
goog.exportSymbol('proto.artifact.OeControlTestDetermination', null, global);
goog.exportSymbol('proto.artifact.OeControlTestGaps', null, global);
goog.exportSymbol('proto.artifact.OeControlTestResult', null, global);
goog.exportSymbol('proto.artifact.ParamInputOption', null, global);
goog.exportSymbol('proto.artifact.PlaybookArtifact', null, global);
goog.exportSymbol('proto.artifact.PlaybookParamInputArtifact', null, global);
goog.exportSymbol('proto.artifact.PoliciesArtifact', null, global);
goog.exportSymbol('proto.artifact.Policy', null, global);
goog.exportSymbol('proto.artifact.PolicyDoc', null, global);
goog.exportSymbol('proto.artifact.QuestionAnswer', null, global);
goog.exportSymbol('proto.artifact.ReportArtifact', null, global);
goog.exportSymbol('proto.artifact.ReportType', null, global);
goog.exportSymbol('proto.artifact.Requirement', null, global);
goog.exportSymbol('proto.artifact.SampledEvidenceArtifact', null, global);
goog.exportSymbol('proto.artifact.Section', null, global);
goog.exportSymbol('proto.artifact.SectionRequirement', null, global);
goog.exportSymbol('proto.artifact.SelectOption', null, global);
goog.exportSymbol('proto.artifact.SelectionArtifact', null, global);
goog.exportSymbol('proto.artifact.Summary', null, global);
goog.exportSymbol('proto.artifact.TestTableArtifact', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.MimeArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.MimeArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.MimeArtifact.displayName = 'proto.artifact.MimeArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.PolicyDoc = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.PolicyDoc, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.PolicyDoc.displayName = 'proto.artifact.PolicyDoc';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.Policy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.Policy.repeatedFields_, null);
};
goog.inherits(proto.artifact.Policy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.Policy.displayName = 'proto.artifact.Policy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.PoliciesArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.PoliciesArtifact.repeatedFields_, null);
};
goog.inherits(proto.artifact.PoliciesArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.PoliciesArtifact.displayName = 'proto.artifact.PoliciesArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.FrameworkDoc = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.FrameworkDoc, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.FrameworkDoc.displayName = 'proto.artifact.FrameworkDoc';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.FrameworkDocArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.FrameworkDocArtifact.repeatedFields_, null);
};
goog.inherits(proto.artifact.FrameworkDocArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.FrameworkDocArtifact.displayName = 'proto.artifact.FrameworkDocArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.SelectOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.SelectOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.SelectOption.displayName = 'proto.artifact.SelectOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.SelectionArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.SelectionArtifact.repeatedFields_, null);
};
goog.inherits(proto.artifact.SelectionArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.SelectionArtifact.displayName = 'proto.artifact.SelectionArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.SectionRequirement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.SectionRequirement.repeatedFields_, null);
};
goog.inherits(proto.artifact.SectionRequirement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.SectionRequirement.displayName = 'proto.artifact.SectionRequirement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.FrameworkSection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.FrameworkSection.repeatedFields_, null);
};
goog.inherits(proto.artifact.FrameworkSection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.FrameworkSection.displayName = 'proto.artifact.FrameworkSection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.FrameworkSectionArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.FrameworkSectionArtifact.repeatedFields_, null);
};
goog.inherits(proto.artifact.FrameworkSectionArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.FrameworkSectionArtifact.displayName = 'proto.artifact.FrameworkSectionArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.QuestionAnswer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.QuestionAnswer.repeatedFields_, null);
};
goog.inherits(proto.artifact.QuestionAnswer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.QuestionAnswer.displayName = 'proto.artifact.QuestionAnswer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.Requirement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.Requirement.repeatedFields_, null);
};
goog.inherits(proto.artifact.Requirement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.Requirement.displayName = 'proto.artifact.Requirement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.Section = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.Section.repeatedFields_, null);
};
goog.inherits(proto.artifact.Section, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.Section.displayName = 'proto.artifact.Section';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.FrameworkQuestionnaireArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.FrameworkQuestionnaireArtifact.repeatedFields_, null);
};
goog.inherits(proto.artifact.FrameworkQuestionnaireArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.FrameworkQuestionnaireArtifact.displayName = 'proto.artifact.FrameworkQuestionnaireArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.CostEstimateArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.CostEstimateArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.CostEstimateArtifact.displayName = 'proto.artifact.CostEstimateArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.TestTableArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.TestTableArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.TestTableArtifact.displayName = 'proto.artifact.TestTableArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.CrossReferenceJoinInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.CrossReferenceJoinInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.CrossReferenceJoinInfo.displayName = 'proto.artifact.CrossReferenceJoinInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.CrossReferencedDataArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.CrossReferencedDataArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.CrossReferencedDataArtifact.displayName = 'proto.artifact.CrossReferencedDataArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.SampledEvidenceArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.SampledEvidenceArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.SampledEvidenceArtifact.displayName = 'proto.artifact.SampledEvidenceArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.FilteredEvidenceArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.FilteredEvidenceArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.FilteredEvidenceArtifact.displayName = 'proto.artifact.FilteredEvidenceArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.Chart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.Chart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.Chart.displayName = 'proto.artifact.Chart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.Summary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.Summary.repeatedFields_, null);
};
goog.inherits(proto.artifact.Summary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.Summary.displayName = 'proto.artifact.Summary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.AttachedArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.artifact.AttachedArtifact.oneofGroups_);
};
goog.inherits(proto.artifact.AttachedArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.AttachedArtifact.displayName = 'proto.artifact.AttachedArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.ReportArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.ReportArtifact.repeatedFields_, null);
};
goog.inherits(proto.artifact.ReportArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.ReportArtifact.displayName = 'proto.artifact.ReportArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.Control = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.Control, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.Control.displayName = 'proto.artifact.Control';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.ControlsArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.ControlsArtifact.repeatedFields_, null);
};
goog.inherits(proto.artifact.ControlsArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.ControlsArtifact.displayName = 'proto.artifact.ControlsArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.OeControlTestGaps = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.OeControlTestGaps.repeatedFields_, null);
};
goog.inherits(proto.artifact.OeControlTestGaps, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.OeControlTestGaps.displayName = 'proto.artifact.OeControlTestGaps';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.OeControlTestCitation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.OeControlTestCitation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.OeControlTestCitation.displayName = 'proto.artifact.OeControlTestCitation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.OeControlTestResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.OeControlTestResult.repeatedFields_, null);
};
goog.inherits(proto.artifact.OeControlTestResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.OeControlTestResult.displayName = 'proto.artifact.OeControlTestResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.OeControlGap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.OeControlGap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.OeControlGap.displayName = 'proto.artifact.OeControlGap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.OeControlResultsArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.OeControlResultsArtifact.repeatedFields_, null);
};
goog.inherits(proto.artifact.OeControlResultsArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.OeControlResultsArtifact.displayName = 'proto.artifact.OeControlResultsArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.PlaybookArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.PlaybookArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.PlaybookArtifact.displayName = 'proto.artifact.PlaybookArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.ParamInputOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.artifact.ParamInputOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.ParamInputOption.displayName = 'proto.artifact.ParamInputOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.PlaybookParamInputArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.artifact.PlaybookParamInputArtifact.repeatedFields_, null);
};
goog.inherits(proto.artifact.PlaybookParamInputArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.PlaybookParamInputArtifact.displayName = 'proto.artifact.PlaybookParamInputArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.artifact.Artifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.artifact.Artifact.oneofGroups_);
};
goog.inherits(proto.artifact.Artifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.artifact.Artifact.displayName = 'proto.artifact.Artifact';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.MimeArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.MimeArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.MimeArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.MimeArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    mime: jspb.Message.getFieldWithDefault(msg, 1, ""),
    data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.MimeArtifact}
 */
proto.artifact.MimeArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.MimeArtifact;
  return proto.artifact.MimeArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.MimeArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.MimeArtifact}
 */
proto.artifact.MimeArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMime(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.MimeArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.MimeArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.MimeArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.MimeArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMime();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string mime = 1;
 * @return {string}
 */
proto.artifact.MimeArtifact.prototype.getMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.MimeArtifact} returns this
 */
proto.artifact.MimeArtifact.prototype.setMime = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.artifact.MimeArtifact.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.artifact.MimeArtifact.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.artifact.MimeArtifact.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.artifact.MimeArtifact} returns this
 */
proto.artifact.MimeArtifact.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.PolicyDoc.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.PolicyDoc.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.PolicyDoc} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.PolicyDoc.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    selected: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    date: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.PolicyDoc}
 */
proto.artifact.PolicyDoc.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.PolicyDoc;
  return proto.artifact.PolicyDoc.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.PolicyDoc} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.PolicyDoc}
 */
proto.artifact.PolicyDoc.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelected(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.PolicyDoc.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.PolicyDoc.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.PolicyDoc} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.PolicyDoc.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSelected();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.artifact.PolicyDoc.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.PolicyDoc} returns this
 */
proto.artifact.PolicyDoc.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content_id = 2;
 * @return {string}
 */
proto.artifact.PolicyDoc.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.PolicyDoc} returns this
 */
proto.artifact.PolicyDoc.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool selected = 3;
 * @return {boolean}
 */
proto.artifact.PolicyDoc.prototype.getSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.PolicyDoc} returns this
 */
proto.artifact.PolicyDoc.prototype.setSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string date = 4;
 * @return {string}
 */
proto.artifact.PolicyDoc.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.PolicyDoc} returns this
 */
proto.artifact.PolicyDoc.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.Policy.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.Policy.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.Policy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.Policy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Policy.toObject = function(includeInstance, msg) {
  var f, obj = {
    modelId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    policyDocsList: jspb.Message.toObjectList(msg.getPolicyDocsList(),
    proto.artifact.PolicyDoc.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.Policy}
 */
proto.artifact.Policy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.Policy;
  return proto.artifact.Policy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.Policy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.Policy}
 */
proto.artifact.Policy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.artifact.PolicyDoc;
      reader.readMessage(value,proto.artifact.PolicyDoc.deserializeBinaryFromReader);
      msg.addPolicyDocs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.Policy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.Policy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.Policy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Policy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPolicyDocsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.artifact.PolicyDoc.serializeBinaryToWriter
    );
  }
};


/**
 * optional string model_id = 1;
 * @return {string}
 */
proto.artifact.Policy.prototype.getModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Policy} returns this
 */
proto.artifact.Policy.prototype.setModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.artifact.Policy.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Policy} returns this
 */
proto.artifact.Policy.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated PolicyDoc policy_docs = 3;
 * @return {!Array<!proto.artifact.PolicyDoc>}
 */
proto.artifact.Policy.prototype.getPolicyDocsList = function() {
  return /** @type{!Array<!proto.artifact.PolicyDoc>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.PolicyDoc, 3));
};


/**
 * @param {!Array<!proto.artifact.PolicyDoc>} value
 * @return {!proto.artifact.Policy} returns this
*/
proto.artifact.Policy.prototype.setPolicyDocsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.artifact.PolicyDoc=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.PolicyDoc}
 */
proto.artifact.Policy.prototype.addPolicyDocs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.artifact.PolicyDoc, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.Policy} returns this
 */
proto.artifact.Policy.prototype.clearPolicyDocsList = function() {
  return this.setPolicyDocsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.PoliciesArtifact.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.PoliciesArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.PoliciesArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.PoliciesArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.PoliciesArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    policiesList: jspb.Message.toObjectList(msg.getPoliciesList(),
    proto.artifact.Policy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.PoliciesArtifact}
 */
proto.artifact.PoliciesArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.PoliciesArtifact;
  return proto.artifact.PoliciesArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.PoliciesArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.PoliciesArtifact}
 */
proto.artifact.PoliciesArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.artifact.Policy;
      reader.readMessage(value,proto.artifact.Policy.deserializeBinaryFromReader);
      msg.addPolicies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.PoliciesArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.PoliciesArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.PoliciesArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.PoliciesArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPoliciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.artifact.Policy.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Policy policies = 1;
 * @return {!Array<!proto.artifact.Policy>}
 */
proto.artifact.PoliciesArtifact.prototype.getPoliciesList = function() {
  return /** @type{!Array<!proto.artifact.Policy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.Policy, 1));
};


/**
 * @param {!Array<!proto.artifact.Policy>} value
 * @return {!proto.artifact.PoliciesArtifact} returns this
*/
proto.artifact.PoliciesArtifact.prototype.setPoliciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.artifact.Policy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.Policy}
 */
proto.artifact.PoliciesArtifact.prototype.addPolicies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.artifact.Policy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.PoliciesArtifact} returns this
 */
proto.artifact.PoliciesArtifact.prototype.clearPoliciesList = function() {
  return this.setPoliciesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.FrameworkDoc.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.FrameworkDoc.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.FrameworkDoc} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FrameworkDoc.toObject = function(includeInstance, msg) {
  var f, obj = {
    fileName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    frameworkName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    curated: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    selected: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.FrameworkDoc}
 */
proto.artifact.FrameworkDoc.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.FrameworkDoc;
  return proto.artifact.FrameworkDoc.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.FrameworkDoc} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.FrameworkDoc}
 */
proto.artifact.FrameworkDoc.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrameworkName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCurated(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.FrameworkDoc.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.FrameworkDoc.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.FrameworkDoc} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FrameworkDoc.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFrameworkName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCurated();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSelected();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string file_name = 1;
 * @return {string}
 */
proto.artifact.FrameworkDoc.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.FrameworkDoc} returns this
 */
proto.artifact.FrameworkDoc.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string framework_name = 2;
 * @return {string}
 */
proto.artifact.FrameworkDoc.prototype.getFrameworkName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.FrameworkDoc} returns this
 */
proto.artifact.FrameworkDoc.prototype.setFrameworkName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string content_id = 3;
 * @return {string}
 */
proto.artifact.FrameworkDoc.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.FrameworkDoc} returns this
 */
proto.artifact.FrameworkDoc.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool curated = 4;
 * @return {boolean}
 */
proto.artifact.FrameworkDoc.prototype.getCurated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.FrameworkDoc} returns this
 */
proto.artifact.FrameworkDoc.prototype.setCurated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool selected = 5;
 * @return {boolean}
 */
proto.artifact.FrameworkDoc.prototype.getSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.FrameworkDoc} returns this
 */
proto.artifact.FrameworkDoc.prototype.setSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.FrameworkDocArtifact.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.FrameworkDocArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.FrameworkDocArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.FrameworkDocArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FrameworkDocArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    frameworkDocsList: jspb.Message.toObjectList(msg.getFrameworkDocsList(),
    proto.artifact.FrameworkDoc.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.FrameworkDocArtifact}
 */
proto.artifact.FrameworkDocArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.FrameworkDocArtifact;
  return proto.artifact.FrameworkDocArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.FrameworkDocArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.FrameworkDocArtifact}
 */
proto.artifact.FrameworkDocArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.artifact.FrameworkDoc;
      reader.readMessage(value,proto.artifact.FrameworkDoc.deserializeBinaryFromReader);
      msg.addFrameworkDocs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.FrameworkDocArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.FrameworkDocArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.FrameworkDocArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FrameworkDocArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameworkDocsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.artifact.FrameworkDoc.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FrameworkDoc framework_docs = 1;
 * @return {!Array<!proto.artifact.FrameworkDoc>}
 */
proto.artifact.FrameworkDocArtifact.prototype.getFrameworkDocsList = function() {
  return /** @type{!Array<!proto.artifact.FrameworkDoc>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.FrameworkDoc, 1));
};


/**
 * @param {!Array<!proto.artifact.FrameworkDoc>} value
 * @return {!proto.artifact.FrameworkDocArtifact} returns this
*/
proto.artifact.FrameworkDocArtifact.prototype.setFrameworkDocsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.artifact.FrameworkDoc=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.FrameworkDoc}
 */
proto.artifact.FrameworkDocArtifact.prototype.addFrameworkDocs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.artifact.FrameworkDoc, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.FrameworkDocArtifact} returns this
 */
proto.artifact.FrameworkDocArtifact.prototype.clearFrameworkDocsList = function() {
  return this.setFrameworkDocsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.SelectOption.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.SelectOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.SelectOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.SelectOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    selected: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.SelectOption}
 */
proto.artifact.SelectOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.SelectOption;
  return proto.artifact.SelectOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.SelectOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.SelectOption}
 */
proto.artifact.SelectOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.SelectOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.SelectOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.SelectOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.SelectOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSelected();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.artifact.SelectOption.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.SelectOption} returns this
 */
proto.artifact.SelectOption.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.artifact.SelectOption.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.SelectOption} returns this
 */
proto.artifact.SelectOption.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool selected = 3;
 * @return {boolean}
 */
proto.artifact.SelectOption.prototype.getSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.SelectOption} returns this
 */
proto.artifact.SelectOption.prototype.setSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.SelectionArtifact.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.SelectionArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.SelectionArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.SelectionArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.SelectionArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    allMultipleSelect: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    selectOptionsList: jspb.Message.toObjectList(msg.getSelectOptionsList(),
    proto.artifact.SelectOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.SelectionArtifact}
 */
proto.artifact.SelectionArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.SelectionArtifact;
  return proto.artifact.SelectionArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.SelectionArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.SelectionArtifact}
 */
proto.artifact.SelectionArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllMultipleSelect(value);
      break;
    case 4:
      var value = new proto.artifact.SelectOption;
      reader.readMessage(value,proto.artifact.SelectOption.deserializeBinaryFromReader);
      msg.addSelectOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.SelectionArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.SelectionArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.SelectionArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.SelectionArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAllMultipleSelect();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getSelectOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.artifact.SelectOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.artifact.SelectionArtifact.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.SelectionArtifact} returns this
 */
proto.artifact.SelectionArtifact.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.artifact.SelectionArtifact.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.SelectionArtifact} returns this
 */
proto.artifact.SelectionArtifact.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool all_multiple_select = 3;
 * @return {boolean}
 */
proto.artifact.SelectionArtifact.prototype.getAllMultipleSelect = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.SelectionArtifact} returns this
 */
proto.artifact.SelectionArtifact.prototype.setAllMultipleSelect = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated SelectOption select_options = 4;
 * @return {!Array<!proto.artifact.SelectOption>}
 */
proto.artifact.SelectionArtifact.prototype.getSelectOptionsList = function() {
  return /** @type{!Array<!proto.artifact.SelectOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.SelectOption, 4));
};


/**
 * @param {!Array<!proto.artifact.SelectOption>} value
 * @return {!proto.artifact.SelectionArtifact} returns this
*/
proto.artifact.SelectionArtifact.prototype.setSelectOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.artifact.SelectOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.SelectOption}
 */
proto.artifact.SelectionArtifact.prototype.addSelectOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.artifact.SelectOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.SelectionArtifact} returns this
 */
proto.artifact.SelectionArtifact.prototype.clearSelectOptionsList = function() {
  return this.setSelectOptionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.SectionRequirement.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.SectionRequirement.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.SectionRequirement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.SectionRequirement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.SectionRequirement.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requirement: jspb.Message.getFieldWithDefault(msg, 2, ""),
    questionsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.SectionRequirement}
 */
proto.artifact.SectionRequirement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.SectionRequirement;
  return proto.artifact.SectionRequirement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.SectionRequirement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.SectionRequirement}
 */
proto.artifact.SectionRequirement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequirement(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addQuestions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.SectionRequirement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.SectionRequirement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.SectionRequirement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.SectionRequirement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequirement();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuestionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.artifact.SectionRequirement.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.SectionRequirement} returns this
 */
proto.artifact.SectionRequirement.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string requirement = 2;
 * @return {string}
 */
proto.artifact.SectionRequirement.prototype.getRequirement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.SectionRequirement} returns this
 */
proto.artifact.SectionRequirement.prototype.setRequirement = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string questions = 3;
 * @return {!Array<string>}
 */
proto.artifact.SectionRequirement.prototype.getQuestionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.artifact.SectionRequirement} returns this
 */
proto.artifact.SectionRequirement.prototype.setQuestionsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.artifact.SectionRequirement} returns this
 */
proto.artifact.SectionRequirement.prototype.addQuestions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.SectionRequirement} returns this
 */
proto.artifact.SectionRequirement.prototype.clearQuestionsList = function() {
  return this.setQuestionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.FrameworkSection.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.FrameworkSection.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.FrameworkSection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.FrameworkSection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FrameworkSection.toObject = function(includeInstance, msg) {
  var f, obj = {
    section: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requirementsList: jspb.Message.toObjectList(msg.getRequirementsList(),
    proto.artifact.SectionRequirement.toObject, includeInstance),
    selected: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.FrameworkSection}
 */
proto.artifact.FrameworkSection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.FrameworkSection;
  return proto.artifact.FrameworkSection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.FrameworkSection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.FrameworkSection}
 */
proto.artifact.FrameworkSection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSection(value);
      break;
    case 2:
      var value = new proto.artifact.SectionRequirement;
      reader.readMessage(value,proto.artifact.SectionRequirement.deserializeBinaryFromReader);
      msg.addRequirements(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.FrameworkSection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.FrameworkSection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.FrameworkSection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FrameworkSection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSection();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequirementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.artifact.SectionRequirement.serializeBinaryToWriter
    );
  }
  f = message.getSelected();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string section = 1;
 * @return {string}
 */
proto.artifact.FrameworkSection.prototype.getSection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.FrameworkSection} returns this
 */
proto.artifact.FrameworkSection.prototype.setSection = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated SectionRequirement requirements = 2;
 * @return {!Array<!proto.artifact.SectionRequirement>}
 */
proto.artifact.FrameworkSection.prototype.getRequirementsList = function() {
  return /** @type{!Array<!proto.artifact.SectionRequirement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.SectionRequirement, 2));
};


/**
 * @param {!Array<!proto.artifact.SectionRequirement>} value
 * @return {!proto.artifact.FrameworkSection} returns this
*/
proto.artifact.FrameworkSection.prototype.setRequirementsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.artifact.SectionRequirement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.SectionRequirement}
 */
proto.artifact.FrameworkSection.prototype.addRequirements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.artifact.SectionRequirement, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.FrameworkSection} returns this
 */
proto.artifact.FrameworkSection.prototype.clearRequirementsList = function() {
  return this.setRequirementsList([]);
};


/**
 * optional bool selected = 3;
 * @return {boolean}
 */
proto.artifact.FrameworkSection.prototype.getSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.FrameworkSection} returns this
 */
proto.artifact.FrameworkSection.prototype.setSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.FrameworkSectionArtifact.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.FrameworkSectionArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.FrameworkSectionArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.FrameworkSectionArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FrameworkSectionArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    frameworkDoc: (f = msg.getFrameworkDoc()) && proto.artifact.FrameworkDoc.toObject(includeInstance, f),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.artifact.FrameworkSection.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.FrameworkSectionArtifact}
 */
proto.artifact.FrameworkSectionArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.FrameworkSectionArtifact;
  return proto.artifact.FrameworkSectionArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.FrameworkSectionArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.FrameworkSectionArtifact}
 */
proto.artifact.FrameworkSectionArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.artifact.FrameworkDoc;
      reader.readMessage(value,proto.artifact.FrameworkDoc.deserializeBinaryFromReader);
      msg.setFrameworkDoc(value);
      break;
    case 2:
      var value = new proto.artifact.FrameworkSection;
      reader.readMessage(value,proto.artifact.FrameworkSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.FrameworkSectionArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.FrameworkSectionArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.FrameworkSectionArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FrameworkSectionArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameworkDoc();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.artifact.FrameworkDoc.serializeBinaryToWriter
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.artifact.FrameworkSection.serializeBinaryToWriter
    );
  }
};


/**
 * optional FrameworkDoc framework_doc = 1;
 * @return {?proto.artifact.FrameworkDoc}
 */
proto.artifact.FrameworkSectionArtifact.prototype.getFrameworkDoc = function() {
  return /** @type{?proto.artifact.FrameworkDoc} */ (
    jspb.Message.getWrapperField(this, proto.artifact.FrameworkDoc, 1));
};


/**
 * @param {?proto.artifact.FrameworkDoc|undefined} value
 * @return {!proto.artifact.FrameworkSectionArtifact} returns this
*/
proto.artifact.FrameworkSectionArtifact.prototype.setFrameworkDoc = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.FrameworkSectionArtifact} returns this
 */
proto.artifact.FrameworkSectionArtifact.prototype.clearFrameworkDoc = function() {
  return this.setFrameworkDoc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.FrameworkSectionArtifact.prototype.hasFrameworkDoc = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated FrameworkSection sections = 2;
 * @return {!Array<!proto.artifact.FrameworkSection>}
 */
proto.artifact.FrameworkSectionArtifact.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.artifact.FrameworkSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.FrameworkSection, 2));
};


/**
 * @param {!Array<!proto.artifact.FrameworkSection>} value
 * @return {!proto.artifact.FrameworkSectionArtifact} returns this
*/
proto.artifact.FrameworkSectionArtifact.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.artifact.FrameworkSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.FrameworkSection}
 */
proto.artifact.FrameworkSectionArtifact.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.artifact.FrameworkSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.FrameworkSectionArtifact} returns this
 */
proto.artifact.FrameworkSectionArtifact.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.QuestionAnswer.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.QuestionAnswer.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.QuestionAnswer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.QuestionAnswer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.QuestionAnswer.toObject = function(includeInstance, msg) {
  var f, obj = {
    question: jspb.Message.getFieldWithDefault(msg, 1, ""),
    answer: jspb.Message.getFieldWithDefault(msg, 2, ""),
    error: jspb.Message.getFieldWithDefault(msg, 3, ""),
    passed: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    citationsList: jspb.Message.toObjectList(msg.getCitationsList(),
    chatcontext_chatcontext_pb.ChatCitation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.QuestionAnswer}
 */
proto.artifact.QuestionAnswer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.QuestionAnswer;
  return proto.artifact.QuestionAnswer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.QuestionAnswer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.QuestionAnswer}
 */
proto.artifact.QuestionAnswer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswer(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPassed(value);
      break;
    case 5:
      var value = new chatcontext_chatcontext_pb.ChatCitation;
      reader.readMessage(value,chatcontext_chatcontext_pb.ChatCitation.deserializeBinaryFromReader);
      msg.addCitations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.QuestionAnswer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.QuestionAnswer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.QuestionAnswer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.QuestionAnswer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnswer();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassed();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      chatcontext_chatcontext_pb.ChatCitation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string question = 1;
 * @return {string}
 */
proto.artifact.QuestionAnswer.prototype.getQuestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.QuestionAnswer} returns this
 */
proto.artifact.QuestionAnswer.prototype.setQuestion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string answer = 2;
 * @return {string}
 */
proto.artifact.QuestionAnswer.prototype.getAnswer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.QuestionAnswer} returns this
 */
proto.artifact.QuestionAnswer.prototype.setAnswer = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string error = 3;
 * @return {string}
 */
proto.artifact.QuestionAnswer.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.QuestionAnswer} returns this
 */
proto.artifact.QuestionAnswer.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool passed = 4;
 * @return {boolean}
 */
proto.artifact.QuestionAnswer.prototype.getPassed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.QuestionAnswer} returns this
 */
proto.artifact.QuestionAnswer.prototype.setPassed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * repeated chatcontext.ChatCitation citations = 5;
 * @return {!Array<!proto.chatcontext.ChatCitation>}
 */
proto.artifact.QuestionAnswer.prototype.getCitationsList = function() {
  return /** @type{!Array<!proto.chatcontext.ChatCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, chatcontext_chatcontext_pb.ChatCitation, 5));
};


/**
 * @param {!Array<!proto.chatcontext.ChatCitation>} value
 * @return {!proto.artifact.QuestionAnswer} returns this
*/
proto.artifact.QuestionAnswer.prototype.setCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.chatcontext.ChatCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chatcontext.ChatCitation}
 */
proto.artifact.QuestionAnswer.prototype.addCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.chatcontext.ChatCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.QuestionAnswer} returns this
 */
proto.artifact.QuestionAnswer.prototype.clearCitationsList = function() {
  return this.setCitationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.Requirement.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.Requirement.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.Requirement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.Requirement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Requirement.toObject = function(includeInstance, msg) {
  var f, obj = {
    requirement: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionAnswersList: jspb.Message.toObjectList(msg.getQuestionAnswersList(),
    proto.artifact.QuestionAnswer.toObject, includeInstance),
    id: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.Requirement}
 */
proto.artifact.Requirement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.Requirement;
  return proto.artifact.Requirement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.Requirement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.Requirement}
 */
proto.artifact.Requirement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequirement(value);
      break;
    case 2:
      var value = new proto.artifact.QuestionAnswer;
      reader.readMessage(value,proto.artifact.QuestionAnswer.deserializeBinaryFromReader);
      msg.addQuestionAnswers(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.Requirement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.Requirement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.Requirement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Requirement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequirement();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionAnswersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.artifact.QuestionAnswer.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string requirement = 1;
 * @return {string}
 */
proto.artifact.Requirement.prototype.getRequirement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Requirement} returns this
 */
proto.artifact.Requirement.prototype.setRequirement = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated QuestionAnswer question_answers = 2;
 * @return {!Array<!proto.artifact.QuestionAnswer>}
 */
proto.artifact.Requirement.prototype.getQuestionAnswersList = function() {
  return /** @type{!Array<!proto.artifact.QuestionAnswer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.QuestionAnswer, 2));
};


/**
 * @param {!Array<!proto.artifact.QuestionAnswer>} value
 * @return {!proto.artifact.Requirement} returns this
*/
proto.artifact.Requirement.prototype.setQuestionAnswersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.artifact.QuestionAnswer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.QuestionAnswer}
 */
proto.artifact.Requirement.prototype.addQuestionAnswers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.artifact.QuestionAnswer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.Requirement} returns this
 */
proto.artifact.Requirement.prototype.clearQuestionAnswersList = function() {
  return this.setQuestionAnswersList([]);
};


/**
 * optional string id = 3;
 * @return {string}
 */
proto.artifact.Requirement.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Requirement} returns this
 */
proto.artifact.Requirement.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.Section.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.Section.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.Section.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.Section} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Section.toObject = function(includeInstance, msg) {
  var f, obj = {
    section: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requirementsList: jspb.Message.toObjectList(msg.getRequirementsList(),
    proto.artifact.Requirement.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.Section}
 */
proto.artifact.Section.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.Section;
  return proto.artifact.Section.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.Section} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.Section}
 */
proto.artifact.Section.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSection(value);
      break;
    case 2:
      var value = new proto.artifact.Requirement;
      reader.readMessage(value,proto.artifact.Requirement.deserializeBinaryFromReader);
      msg.addRequirements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.Section.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.Section.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.Section} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Section.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSection();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequirementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.artifact.Requirement.serializeBinaryToWriter
    );
  }
};


/**
 * optional string section = 1;
 * @return {string}
 */
proto.artifact.Section.prototype.getSection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Section} returns this
 */
proto.artifact.Section.prototype.setSection = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Requirement requirements = 2;
 * @return {!Array<!proto.artifact.Requirement>}
 */
proto.artifact.Section.prototype.getRequirementsList = function() {
  return /** @type{!Array<!proto.artifact.Requirement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.Requirement, 2));
};


/**
 * @param {!Array<!proto.artifact.Requirement>} value
 * @return {!proto.artifact.Section} returns this
*/
proto.artifact.Section.prototype.setRequirementsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.artifact.Requirement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.Requirement}
 */
proto.artifact.Section.prototype.addRequirements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.artifact.Requirement, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.Section} returns this
 */
proto.artifact.Section.prototype.clearRequirementsList = function() {
  return this.setRequirementsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.FrameworkQuestionnaireArtifact.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.FrameworkQuestionnaireArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.FrameworkQuestionnaireArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.FrameworkQuestionnaireArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FrameworkQuestionnaireArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    frameworkName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.artifact.Section.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.FrameworkQuestionnaireArtifact}
 */
proto.artifact.FrameworkQuestionnaireArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.FrameworkQuestionnaireArtifact;
  return proto.artifact.FrameworkQuestionnaireArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.FrameworkQuestionnaireArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.FrameworkQuestionnaireArtifact}
 */
proto.artifact.FrameworkQuestionnaireArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrameworkName(value);
      break;
    case 2:
      var value = new proto.artifact.Section;
      reader.readMessage(value,proto.artifact.Section.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.FrameworkQuestionnaireArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.FrameworkQuestionnaireArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.FrameworkQuestionnaireArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FrameworkQuestionnaireArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameworkName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.artifact.Section.serializeBinaryToWriter
    );
  }
};


/**
 * optional string framework_name = 1;
 * @return {string}
 */
proto.artifact.FrameworkQuestionnaireArtifact.prototype.getFrameworkName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.FrameworkQuestionnaireArtifact} returns this
 */
proto.artifact.FrameworkQuestionnaireArtifact.prototype.setFrameworkName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Section sections = 2;
 * @return {!Array<!proto.artifact.Section>}
 */
proto.artifact.FrameworkQuestionnaireArtifact.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.artifact.Section>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.Section, 2));
};


/**
 * @param {!Array<!proto.artifact.Section>} value
 * @return {!proto.artifact.FrameworkQuestionnaireArtifact} returns this
*/
proto.artifact.FrameworkQuestionnaireArtifact.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.artifact.Section=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.Section}
 */
proto.artifact.FrameworkQuestionnaireArtifact.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.artifact.Section, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.FrameworkQuestionnaireArtifact} returns this
 */
proto.artifact.FrameworkQuestionnaireArtifact.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.CostEstimateArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.CostEstimateArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.CostEstimateArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.CostEstimateArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    cost: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    unit: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.CostEstimateArtifact}
 */
proto.artifact.CostEstimateArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.CostEstimateArtifact;
  return proto.artifact.CostEstimateArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.CostEstimateArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.CostEstimateArtifact}
 */
proto.artifact.CostEstimateArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCost(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.CostEstimateArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.CostEstimateArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.CostEstimateArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.CostEstimateArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCost();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getUnit();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional double cost = 1;
 * @return {number}
 */
proto.artifact.CostEstimateArtifact.prototype.getCost = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.artifact.CostEstimateArtifact} returns this
 */
proto.artifact.CostEstimateArtifact.prototype.setCost = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional string unit = 2;
 * @return {string}
 */
proto.artifact.CostEstimateArtifact.prototype.getUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CostEstimateArtifact} returns this
 */
proto.artifact.CostEstimateArtifact.prototype.setUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.artifact.CostEstimateArtifact.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CostEstimateArtifact} returns this
 */
proto.artifact.CostEstimateArtifact.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.TestTableArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.TestTableArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.TestTableArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.TestTableArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    testTable: (f = msg.getTestTable()) && auditbotapi_auditbotapi_pb.TestTable.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.TestTableArtifact}
 */
proto.artifact.TestTableArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.TestTableArtifact;
  return proto.artifact.TestTableArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.TestTableArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.TestTableArtifact}
 */
proto.artifact.TestTableArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new auditbotapi_auditbotapi_pb.TestTable;
      reader.readMessage(value,auditbotapi_auditbotapi_pb.TestTable.deserializeBinaryFromReader);
      msg.setTestTable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.TestTableArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.TestTableArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.TestTableArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.TestTableArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestTable();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      auditbotapi_auditbotapi_pb.TestTable.serializeBinaryToWriter
    );
  }
};


/**
 * optional auditbotapi.TestTable test_table = 1;
 * @return {?proto.auditbotapi.TestTable}
 */
proto.artifact.TestTableArtifact.prototype.getTestTable = function() {
  return /** @type{?proto.auditbotapi.TestTable} */ (
    jspb.Message.getWrapperField(this, auditbotapi_auditbotapi_pb.TestTable, 1));
};


/**
 * @param {?proto.auditbotapi.TestTable|undefined} value
 * @return {!proto.artifact.TestTableArtifact} returns this
*/
proto.artifact.TestTableArtifact.prototype.setTestTable = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.TestTableArtifact} returns this
 */
proto.artifact.TestTableArtifact.prototype.clearTestTable = function() {
  return this.setTestTable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.TestTableArtifact.prototype.hasTestTable = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.CrossReferenceJoinInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.CrossReferenceJoinInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.CrossReferenceJoinInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.CrossReferenceJoinInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    leftTable: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rightTable: jspb.Message.getFieldWithDefault(msg, 2, ""),
    leftOn: jspb.Message.getFieldWithDefault(msg, 3, ""),
    rightOn: jspb.Message.getFieldWithDefault(msg, 4, ""),
    joinType: jspb.Message.getFieldWithDefault(msg, 5, ""),
    totalRows: jspb.Message.getFieldWithDefault(msg, 6, 0),
    matchedRows: jspb.Message.getFieldWithDefault(msg, 7, 0),
    leftOnly: jspb.Message.getFieldWithDefault(msg, 8, 0),
    rightOnly: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.CrossReferenceJoinInfo}
 */
proto.artifact.CrossReferenceJoinInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.CrossReferenceJoinInfo;
  return proto.artifact.CrossReferenceJoinInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.CrossReferenceJoinInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.CrossReferenceJoinInfo}
 */
proto.artifact.CrossReferenceJoinInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeftTable(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRightTable(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeftOn(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRightOn(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setJoinType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalRows(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMatchedRows(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeftOnly(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRightOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.CrossReferenceJoinInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.CrossReferenceJoinInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.CrossReferenceJoinInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.CrossReferenceJoinInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLeftTable();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRightTable();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLeftOn();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRightOn();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getJoinType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMatchedRows();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getLeftOnly();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getRightOnly();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string left_table = 1;
 * @return {string}
 */
proto.artifact.CrossReferenceJoinInfo.prototype.getLeftTable = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CrossReferenceJoinInfo} returns this
 */
proto.artifact.CrossReferenceJoinInfo.prototype.setLeftTable = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string right_table = 2;
 * @return {string}
 */
proto.artifact.CrossReferenceJoinInfo.prototype.getRightTable = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CrossReferenceJoinInfo} returns this
 */
proto.artifact.CrossReferenceJoinInfo.prototype.setRightTable = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string left_on = 3;
 * @return {string}
 */
proto.artifact.CrossReferenceJoinInfo.prototype.getLeftOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CrossReferenceJoinInfo} returns this
 */
proto.artifact.CrossReferenceJoinInfo.prototype.setLeftOn = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string right_on = 4;
 * @return {string}
 */
proto.artifact.CrossReferenceJoinInfo.prototype.getRightOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CrossReferenceJoinInfo} returns this
 */
proto.artifact.CrossReferenceJoinInfo.prototype.setRightOn = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string join_type = 5;
 * @return {string}
 */
proto.artifact.CrossReferenceJoinInfo.prototype.getJoinType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CrossReferenceJoinInfo} returns this
 */
proto.artifact.CrossReferenceJoinInfo.prototype.setJoinType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 total_rows = 6;
 * @return {number}
 */
proto.artifact.CrossReferenceJoinInfo.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.artifact.CrossReferenceJoinInfo} returns this
 */
proto.artifact.CrossReferenceJoinInfo.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 matched_rows = 7;
 * @return {number}
 */
proto.artifact.CrossReferenceJoinInfo.prototype.getMatchedRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.artifact.CrossReferenceJoinInfo} returns this
 */
proto.artifact.CrossReferenceJoinInfo.prototype.setMatchedRows = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 left_only = 8;
 * @return {number}
 */
proto.artifact.CrossReferenceJoinInfo.prototype.getLeftOnly = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.artifact.CrossReferenceJoinInfo} returns this
 */
proto.artifact.CrossReferenceJoinInfo.prototype.setLeftOnly = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 right_only = 9;
 * @return {number}
 */
proto.artifact.CrossReferenceJoinInfo.prototype.getRightOnly = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.artifact.CrossReferenceJoinInfo} returns this
 */
proto.artifact.CrossReferenceJoinInfo.prototype.setRightOnly = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.CrossReferencedDataArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.CrossReferencedDataArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.CrossReferencedDataArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.CrossReferencedDataArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceInstanceId1: jspb.Message.getFieldWithDefault(msg, 1, ""),
    evidenceInstanceId2: jspb.Message.getFieldWithDefault(msg, 2, ""),
    joinCriteria: jspb.Message.getFieldWithDefault(msg, 3, ""),
    joinDescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
    joinInfo: (f = msg.getJoinInfo()) && proto.artifact.CrossReferenceJoinInfo.toObject(includeInstance, f),
    table: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.CrossReferencedDataArtifact}
 */
proto.artifact.CrossReferencedDataArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.CrossReferencedDataArtifact;
  return proto.artifact.CrossReferencedDataArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.CrossReferencedDataArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.CrossReferencedDataArtifact}
 */
proto.artifact.CrossReferencedDataArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceInstanceId1(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceInstanceId2(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setJoinCriteria(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setJoinDescription(value);
      break;
    case 5:
      var value = new proto.artifact.CrossReferenceJoinInfo;
      reader.readMessage(value,proto.artifact.CrossReferenceJoinInfo.deserializeBinaryFromReader);
      msg.setJoinInfo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.CrossReferencedDataArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.CrossReferencedDataArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.CrossReferencedDataArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.CrossReferencedDataArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceInstanceId1();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEvidenceInstanceId2();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getJoinCriteria();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getJoinDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getJoinInfo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.artifact.CrossReferenceJoinInfo.serializeBinaryToWriter
    );
  }
  f = message.getTable();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string evidence_instance_id_1 = 1;
 * @return {string}
 */
proto.artifact.CrossReferencedDataArtifact.prototype.getEvidenceInstanceId1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CrossReferencedDataArtifact} returns this
 */
proto.artifact.CrossReferencedDataArtifact.prototype.setEvidenceInstanceId1 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string evidence_instance_id_2 = 2;
 * @return {string}
 */
proto.artifact.CrossReferencedDataArtifact.prototype.getEvidenceInstanceId2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CrossReferencedDataArtifact} returns this
 */
proto.artifact.CrossReferencedDataArtifact.prototype.setEvidenceInstanceId2 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string join_criteria = 3;
 * @return {string}
 */
proto.artifact.CrossReferencedDataArtifact.prototype.getJoinCriteria = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CrossReferencedDataArtifact} returns this
 */
proto.artifact.CrossReferencedDataArtifact.prototype.setJoinCriteria = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string join_description = 4;
 * @return {string}
 */
proto.artifact.CrossReferencedDataArtifact.prototype.getJoinDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CrossReferencedDataArtifact} returns this
 */
proto.artifact.CrossReferencedDataArtifact.prototype.setJoinDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional CrossReferenceJoinInfo join_info = 5;
 * @return {?proto.artifact.CrossReferenceJoinInfo}
 */
proto.artifact.CrossReferencedDataArtifact.prototype.getJoinInfo = function() {
  return /** @type{?proto.artifact.CrossReferenceJoinInfo} */ (
    jspb.Message.getWrapperField(this, proto.artifact.CrossReferenceJoinInfo, 5));
};


/**
 * @param {?proto.artifact.CrossReferenceJoinInfo|undefined} value
 * @return {!proto.artifact.CrossReferencedDataArtifact} returns this
*/
proto.artifact.CrossReferencedDataArtifact.prototype.setJoinInfo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.CrossReferencedDataArtifact} returns this
 */
proto.artifact.CrossReferencedDataArtifact.prototype.clearJoinInfo = function() {
  return this.setJoinInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.CrossReferencedDataArtifact.prototype.hasJoinInfo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string table = 6;
 * @return {string}
 */
proto.artifact.CrossReferencedDataArtifact.prototype.getTable = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.CrossReferencedDataArtifact} returns this
 */
proto.artifact.CrossReferencedDataArtifact.prototype.setTable = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.SampledEvidenceArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.SampledEvidenceArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.SampledEvidenceArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.SampledEvidenceArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceInstanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    numSampledRows: jspb.Message.getFieldWithDefault(msg, 3, 0),
    table: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.SampledEvidenceArtifact}
 */
proto.artifact.SampledEvidenceArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.SampledEvidenceArtifact;
  return proto.artifact.SampledEvidenceArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.SampledEvidenceArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.SampledEvidenceArtifact}
 */
proto.artifact.SampledEvidenceArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceInstanceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumSampledRows(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.SampledEvidenceArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.SampledEvidenceArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.SampledEvidenceArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.SampledEvidenceArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNumSampledRows();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTable();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string evidence_instance_id = 1;
 * @return {string}
 */
proto.artifact.SampledEvidenceArtifact.prototype.getEvidenceInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.SampledEvidenceArtifact} returns this
 */
proto.artifact.SampledEvidenceArtifact.prototype.setEvidenceInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.artifact.SampledEvidenceArtifact.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.SampledEvidenceArtifact} returns this
 */
proto.artifact.SampledEvidenceArtifact.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 num_sampled_rows = 3;
 * @return {number}
 */
proto.artifact.SampledEvidenceArtifact.prototype.getNumSampledRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.artifact.SampledEvidenceArtifact} returns this
 */
proto.artifact.SampledEvidenceArtifact.prototype.setNumSampledRows = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string table = 4;
 * @return {string}
 */
proto.artifact.SampledEvidenceArtifact.prototype.getTable = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.SampledEvidenceArtifact} returns this
 */
proto.artifact.SampledEvidenceArtifact.prototype.setTable = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.FilteredEvidenceArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.FilteredEvidenceArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.FilteredEvidenceArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FilteredEvidenceArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceInstanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filterDescription: jspb.Message.getFieldWithDefault(msg, 2, ""),
    regexPattern: jspb.Message.getFieldWithDefault(msg, 3, ""),
    filteredColumn: jspb.Message.getFieldWithDefault(msg, 4, ""),
    matchedRows: jspb.Message.getFieldWithDefault(msg, 5, 0),
    totalRows: jspb.Message.getFieldWithDefault(msg, 6, 0),
    table: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.FilteredEvidenceArtifact}
 */
proto.artifact.FilteredEvidenceArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.FilteredEvidenceArtifact;
  return proto.artifact.FilteredEvidenceArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.FilteredEvidenceArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.FilteredEvidenceArtifact}
 */
proto.artifact.FilteredEvidenceArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceInstanceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilterDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegexPattern(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilteredColumn(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMatchedRows(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalRows(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.FilteredEvidenceArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.FilteredEvidenceArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.FilteredEvidenceArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.FilteredEvidenceArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceInstanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilterDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRegexPattern();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFilteredColumn();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMatchedRows();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTable();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string evidence_instance_id = 1;
 * @return {string}
 */
proto.artifact.FilteredEvidenceArtifact.prototype.getEvidenceInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.FilteredEvidenceArtifact} returns this
 */
proto.artifact.FilteredEvidenceArtifact.prototype.setEvidenceInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filter_description = 2;
 * @return {string}
 */
proto.artifact.FilteredEvidenceArtifact.prototype.getFilterDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.FilteredEvidenceArtifact} returns this
 */
proto.artifact.FilteredEvidenceArtifact.prototype.setFilterDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string regex_pattern = 3;
 * @return {string}
 */
proto.artifact.FilteredEvidenceArtifact.prototype.getRegexPattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.FilteredEvidenceArtifact} returns this
 */
proto.artifact.FilteredEvidenceArtifact.prototype.setRegexPattern = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string filtered_column = 4;
 * @return {string}
 */
proto.artifact.FilteredEvidenceArtifact.prototype.getFilteredColumn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.FilteredEvidenceArtifact} returns this
 */
proto.artifact.FilteredEvidenceArtifact.prototype.setFilteredColumn = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 matched_rows = 5;
 * @return {number}
 */
proto.artifact.FilteredEvidenceArtifact.prototype.getMatchedRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.artifact.FilteredEvidenceArtifact} returns this
 */
proto.artifact.FilteredEvidenceArtifact.prototype.setMatchedRows = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 total_rows = 6;
 * @return {number}
 */
proto.artifact.FilteredEvidenceArtifact.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.artifact.FilteredEvidenceArtifact} returns this
 */
proto.artifact.FilteredEvidenceArtifact.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string table = 7;
 * @return {string}
 */
proto.artifact.FilteredEvidenceArtifact.prototype.getTable = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.FilteredEvidenceArtifact} returns this
 */
proto.artifact.FilteredEvidenceArtifact.prototype.setTable = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.Chart.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.Chart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.Chart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Chart.toObject = function(includeInstance, msg) {
  var f, obj = {
    chartConfigJson: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.Chart}
 */
proto.artifact.Chart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.Chart;
  return proto.artifact.Chart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.Chart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.Chart}
 */
proto.artifact.Chart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChartConfigJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.Chart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.Chart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.Chart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Chart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChartConfigJson();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string chart_config_json = 1;
 * @return {string}
 */
proto.artifact.Chart.prototype.getChartConfigJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Chart} returns this
 */
proto.artifact.Chart.prototype.setChartConfigJson = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.Summary.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.Summary.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.Summary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.Summary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Summary.toObject = function(includeInstance, msg) {
  var f, obj = {
    summary: jspb.Message.getFieldWithDefault(msg, 1, ""),
    chartsList: jspb.Message.toObjectList(msg.getChartsList(),
    proto.artifact.Chart.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.Summary}
 */
proto.artifact.Summary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.Summary;
  return proto.artifact.Summary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.Summary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.Summary}
 */
proto.artifact.Summary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 2:
      var value = new proto.artifact.Chart;
      reader.readMessage(value,proto.artifact.Chart.deserializeBinaryFromReader);
      msg.addCharts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.Summary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.Summary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.Summary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Summary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChartsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.artifact.Chart.serializeBinaryToWriter
    );
  }
};


/**
 * optional string summary = 1;
 * @return {string}
 */
proto.artifact.Summary.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Summary} returns this
 */
proto.artifact.Summary.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Chart charts = 2;
 * @return {!Array<!proto.artifact.Chart>}
 */
proto.artifact.Summary.prototype.getChartsList = function() {
  return /** @type{!Array<!proto.artifact.Chart>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.Chart, 2));
};


/**
 * @param {!Array<!proto.artifact.Chart>} value
 * @return {!proto.artifact.Summary} returns this
*/
proto.artifact.Summary.prototype.setChartsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.artifact.Chart=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.Chart}
 */
proto.artifact.Summary.prototype.addCharts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.artifact.Chart, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.Summary} returns this
 */
proto.artifact.Summary.prototype.clearChartsList = function() {
  return this.setChartsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.artifact.AttachedArtifact.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.artifact.AttachedArtifact.ArtifactDataCase = {
  ARTIFACT_DATA_NOT_SET: 0,
  FRAMEWORK_QUESTIONNAIRE_ARTIFACT: 1
};

/**
 * @return {proto.artifact.AttachedArtifact.ArtifactDataCase}
 */
proto.artifact.AttachedArtifact.prototype.getArtifactDataCase = function() {
  return /** @type {proto.artifact.AttachedArtifact.ArtifactDataCase} */(jspb.Message.computeOneofCase(this, proto.artifact.AttachedArtifact.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.AttachedArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.AttachedArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.AttachedArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.AttachedArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    frameworkQuestionnaireArtifact: (f = msg.getFrameworkQuestionnaireArtifact()) && proto.artifact.FrameworkQuestionnaireArtifact.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.AttachedArtifact}
 */
proto.artifact.AttachedArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.AttachedArtifact;
  return proto.artifact.AttachedArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.AttachedArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.AttachedArtifact}
 */
proto.artifact.AttachedArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.artifact.FrameworkQuestionnaireArtifact;
      reader.readMessage(value,proto.artifact.FrameworkQuestionnaireArtifact.deserializeBinaryFromReader);
      msg.setFrameworkQuestionnaireArtifact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.AttachedArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.AttachedArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.AttachedArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.AttachedArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameworkQuestionnaireArtifact();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.artifact.FrameworkQuestionnaireArtifact.serializeBinaryToWriter
    );
  }
};


/**
 * optional FrameworkQuestionnaireArtifact framework_questionnaire_artifact = 1;
 * @return {?proto.artifact.FrameworkQuestionnaireArtifact}
 */
proto.artifact.AttachedArtifact.prototype.getFrameworkQuestionnaireArtifact = function() {
  return /** @type{?proto.artifact.FrameworkQuestionnaireArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.FrameworkQuestionnaireArtifact, 1));
};


/**
 * @param {?proto.artifact.FrameworkQuestionnaireArtifact|undefined} value
 * @return {!proto.artifact.AttachedArtifact} returns this
*/
proto.artifact.AttachedArtifact.prototype.setFrameworkQuestionnaireArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.artifact.AttachedArtifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.AttachedArtifact} returns this
 */
proto.artifact.AttachedArtifact.prototype.clearFrameworkQuestionnaireArtifact = function() {
  return this.setFrameworkQuestionnaireArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.AttachedArtifact.prototype.hasFrameworkQuestionnaireArtifact = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.ReportArtifact.repeatedFields_ = [2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.ReportArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.ReportArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.ReportArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.ReportArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    summariesList: jspb.Message.toObjectList(msg.getSummariesList(),
    proto.artifact.Summary.toObject, includeInstance),
    chartsList: jspb.Message.toObjectList(msg.getChartsList(),
    proto.artifact.Chart.toObject, includeInstance),
    attachmentsList: jspb.Message.toObjectList(msg.getAttachmentsList(),
    proto.artifact.AttachedArtifact.toObject, includeInstance),
    title: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.ReportArtifact}
 */
proto.artifact.ReportArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.ReportArtifact;
  return proto.artifact.ReportArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.ReportArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.ReportArtifact}
 */
proto.artifact.ReportArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.artifact.ReportType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.artifact.Summary;
      reader.readMessage(value,proto.artifact.Summary.deserializeBinaryFromReader);
      msg.addSummaries(value);
      break;
    case 3:
      var value = new proto.artifact.Chart;
      reader.readMessage(value,proto.artifact.Chart.deserializeBinaryFromReader);
      msg.addCharts(value);
      break;
    case 4:
      var value = new proto.artifact.AttachedArtifact;
      reader.readMessage(value,proto.artifact.AttachedArtifact.deserializeBinaryFromReader);
      msg.addAttachments(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.ReportArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.ReportArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.ReportArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.ReportArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSummariesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.artifact.Summary.serializeBinaryToWriter
    );
  }
  f = message.getChartsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.artifact.Chart.serializeBinaryToWriter
    );
  }
  f = message.getAttachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.artifact.AttachedArtifact.serializeBinaryToWriter
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional ReportType type = 1;
 * @return {!proto.artifact.ReportType}
 */
proto.artifact.ReportArtifact.prototype.getType = function() {
  return /** @type {!proto.artifact.ReportType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.artifact.ReportType} value
 * @return {!proto.artifact.ReportArtifact} returns this
 */
proto.artifact.ReportArtifact.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated Summary summaries = 2;
 * @return {!Array<!proto.artifact.Summary>}
 */
proto.artifact.ReportArtifact.prototype.getSummariesList = function() {
  return /** @type{!Array<!proto.artifact.Summary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.Summary, 2));
};


/**
 * @param {!Array<!proto.artifact.Summary>} value
 * @return {!proto.artifact.ReportArtifact} returns this
*/
proto.artifact.ReportArtifact.prototype.setSummariesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.artifact.Summary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.Summary}
 */
proto.artifact.ReportArtifact.prototype.addSummaries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.artifact.Summary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.ReportArtifact} returns this
 */
proto.artifact.ReportArtifact.prototype.clearSummariesList = function() {
  return this.setSummariesList([]);
};


/**
 * repeated Chart charts = 3;
 * @return {!Array<!proto.artifact.Chart>}
 */
proto.artifact.ReportArtifact.prototype.getChartsList = function() {
  return /** @type{!Array<!proto.artifact.Chart>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.Chart, 3));
};


/**
 * @param {!Array<!proto.artifact.Chart>} value
 * @return {!proto.artifact.ReportArtifact} returns this
*/
proto.artifact.ReportArtifact.prototype.setChartsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.artifact.Chart=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.Chart}
 */
proto.artifact.ReportArtifact.prototype.addCharts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.artifact.Chart, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.ReportArtifact} returns this
 */
proto.artifact.ReportArtifact.prototype.clearChartsList = function() {
  return this.setChartsList([]);
};


/**
 * repeated AttachedArtifact attachments = 4;
 * @return {!Array<!proto.artifact.AttachedArtifact>}
 */
proto.artifact.ReportArtifact.prototype.getAttachmentsList = function() {
  return /** @type{!Array<!proto.artifact.AttachedArtifact>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.AttachedArtifact, 4));
};


/**
 * @param {!Array<!proto.artifact.AttachedArtifact>} value
 * @return {!proto.artifact.ReportArtifact} returns this
*/
proto.artifact.ReportArtifact.prototype.setAttachmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.artifact.AttachedArtifact=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.AttachedArtifact}
 */
proto.artifact.ReportArtifact.prototype.addAttachments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.artifact.AttachedArtifact, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.ReportArtifact} returns this
 */
proto.artifact.ReportArtifact.prototype.clearAttachmentsList = function() {
  return this.setAttachmentsList([]);
};


/**
 * optional string title = 5;
 * @return {string}
 */
proto.artifact.ReportArtifact.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.ReportArtifact} returns this
 */
proto.artifact.ReportArtifact.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.Control.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.Control.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.Control} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Control.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    modelId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    selected: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.Control}
 */
proto.artifact.Control.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.Control;
  return proto.artifact.Control.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.Control} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.Control}
 */
proto.artifact.Control.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.Control.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.Control.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.Control} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Control.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getModelId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSelected();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.artifact.Control.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Control} returns this
 */
proto.artifact.Control.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string model_id = 2;
 * @return {string}
 */
proto.artifact.Control.prototype.getModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Control} returns this
 */
proto.artifact.Control.prototype.setModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.artifact.Control.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Control} returns this
 */
proto.artifact.Control.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool selected = 4;
 * @return {boolean}
 */
proto.artifact.Control.prototype.getSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.Control} returns this
 */
proto.artifact.Control.prototype.setSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.ControlsArtifact.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.ControlsArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.ControlsArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.ControlsArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.ControlsArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlsList: jspb.Message.toObjectList(msg.getControlsList(),
    proto.artifact.Control.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.ControlsArtifact}
 */
proto.artifact.ControlsArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.ControlsArtifact;
  return proto.artifact.ControlsArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.ControlsArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.ControlsArtifact}
 */
proto.artifact.ControlsArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.artifact.Control;
      reader.readMessage(value,proto.artifact.Control.deserializeBinaryFromReader);
      msg.addControls(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.ControlsArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.ControlsArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.ControlsArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.ControlsArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.artifact.Control.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Control controls = 1;
 * @return {!Array<!proto.artifact.Control>}
 */
proto.artifact.ControlsArtifact.prototype.getControlsList = function() {
  return /** @type{!Array<!proto.artifact.Control>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.Control, 1));
};


/**
 * @param {!Array<!proto.artifact.Control>} value
 * @return {!proto.artifact.ControlsArtifact} returns this
*/
proto.artifact.ControlsArtifact.prototype.setControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.artifact.Control=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.Control}
 */
proto.artifact.ControlsArtifact.prototype.addControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.artifact.Control, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.ControlsArtifact} returns this
 */
proto.artifact.ControlsArtifact.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.OeControlTestGaps.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.OeControlTestGaps.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.OeControlTestGaps.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.OeControlTestGaps} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.OeControlTestGaps.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    remediationsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.OeControlTestGaps}
 */
proto.artifact.OeControlTestGaps.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.OeControlTestGaps;
  return proto.artifact.OeControlTestGaps.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.OeControlTestGaps} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.OeControlTestGaps}
 */
proto.artifact.OeControlTestGaps.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.artifact.GapType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addRemediations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.OeControlTestGaps.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.OeControlTestGaps.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.OeControlTestGaps} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.OeControlTestGaps.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRemediationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional GapType type = 1;
 * @return {!proto.artifact.GapType}
 */
proto.artifact.OeControlTestGaps.prototype.getType = function() {
  return /** @type {!proto.artifact.GapType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.artifact.GapType} value
 * @return {!proto.artifact.OeControlTestGaps} returns this
 */
proto.artifact.OeControlTestGaps.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.artifact.OeControlTestGaps.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestGaps} returns this
 */
proto.artifact.OeControlTestGaps.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string remediations = 3;
 * @return {!Array<string>}
 */
proto.artifact.OeControlTestGaps.prototype.getRemediationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.artifact.OeControlTestGaps} returns this
 */
proto.artifact.OeControlTestGaps.prototype.setRemediationsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.artifact.OeControlTestGaps} returns this
 */
proto.artifact.OeControlTestGaps.prototype.addRemediations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.OeControlTestGaps} returns this
 */
proto.artifact.OeControlTestGaps.prototype.clearRemediationsList = function() {
  return this.setRemediationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.OeControlTestCitation.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.OeControlTestCitation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.OeControlTestCitation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.OeControlTestCitation.toObject = function(includeInstance, msg) {
  var f, obj = {
    citationType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    evidenceCaption: jspb.Message.getFieldWithDefault(msg, 2, ""),
    evidenceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    documentId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    relevantDate: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isApplicable: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    applicableReason: jspb.Message.getFieldWithDefault(msg, 7, ""),
    supportedDetermination: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    findingSummary: jspb.Message.getFieldWithDefault(msg, 9, ""),
    exceptionsFound: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    exceptionDetails: jspb.Message.getFieldWithDefault(msg, 11, ""),
    nonOccurrence: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    nonOccurrenceReason: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.OeControlTestCitation}
 */
proto.artifact.OeControlTestCitation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.OeControlTestCitation;
  return proto.artifact.OeControlTestCitation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.OeControlTestCitation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.OeControlTestCitation}
 */
proto.artifact.OeControlTestCitation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.artifact.OeControlTestCitationType} */ (reader.readEnum());
      msg.setCitationType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceCaption(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelevantDate(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsApplicable(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicableReason(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportedDetermination(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFindingSummary(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExceptionsFound(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setExceptionDetails(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNonOccurrence(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonOccurrenceReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.OeControlTestCitation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.OeControlTestCitation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.OeControlTestCitation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.OeControlTestCitation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCitationType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getEvidenceCaption();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDocumentId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRelevantDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsApplicable();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getApplicableReason();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSupportedDetermination();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getFindingSummary();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getExceptionsFound();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getExceptionDetails();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getNonOccurrence();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getNonOccurrenceReason();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional OeControlTestCitationType citation_type = 1;
 * @return {!proto.artifact.OeControlTestCitationType}
 */
proto.artifact.OeControlTestCitation.prototype.getCitationType = function() {
  return /** @type {!proto.artifact.OeControlTestCitationType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.artifact.OeControlTestCitationType} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setCitationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string evidence_caption = 2;
 * @return {string}
 */
proto.artifact.OeControlTestCitation.prototype.getEvidenceCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setEvidenceCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string evidence_id = 3;
 * @return {string}
 */
proto.artifact.OeControlTestCitation.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string document_id = 4;
 * @return {string}
 */
proto.artifact.OeControlTestCitation.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setDocumentId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string relevant_date = 5;
 * @return {string}
 */
proto.artifact.OeControlTestCitation.prototype.getRelevantDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setRelevantDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_applicable = 6;
 * @return {boolean}
 */
proto.artifact.OeControlTestCitation.prototype.getIsApplicable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setIsApplicable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string applicable_reason = 7;
 * @return {string}
 */
proto.artifact.OeControlTestCitation.prototype.getApplicableReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setApplicableReason = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool supported_determination = 8;
 * @return {boolean}
 */
proto.artifact.OeControlTestCitation.prototype.getSupportedDetermination = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setSupportedDetermination = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string finding_summary = 9;
 * @return {string}
 */
proto.artifact.OeControlTestCitation.prototype.getFindingSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setFindingSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool exceptions_found = 10;
 * @return {boolean}
 */
proto.artifact.OeControlTestCitation.prototype.getExceptionsFound = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setExceptionsFound = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string exception_details = 11;
 * @return {string}
 */
proto.artifact.OeControlTestCitation.prototype.getExceptionDetails = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setExceptionDetails = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool non_occurrence = 12;
 * @return {boolean}
 */
proto.artifact.OeControlTestCitation.prototype.getNonOccurrence = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setNonOccurrence = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string non_occurrence_reason = 13;
 * @return {string}
 */
proto.artifact.OeControlTestCitation.prototype.getNonOccurrenceReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestCitation} returns this
 */
proto.artifact.OeControlTestCitation.prototype.setNonOccurrenceReason = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.OeControlTestResult.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.OeControlTestResult.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.OeControlTestResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.OeControlTestResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.OeControlTestResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    testString: jspb.Message.getFieldWithDefault(msg, 1, ""),
    determination: jspb.Message.getFieldWithDefault(msg, 2, 0),
    reasoning: jspb.Message.getFieldWithDefault(msg, 3, ""),
    recommendedActions: jspb.Message.getFieldWithDefault(msg, 4, ""),
    citationsList: jspb.Message.toObjectList(msg.getCitationsList(),
    proto.artifact.OeControlTestCitation.toObject, includeInstance),
    gapsList: jspb.Message.toObjectList(msg.getGapsList(),
    proto.artifact.OeControlTestGaps.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.OeControlTestResult}
 */
proto.artifact.OeControlTestResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.OeControlTestResult;
  return proto.artifact.OeControlTestResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.OeControlTestResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.OeControlTestResult}
 */
proto.artifact.OeControlTestResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTestString(value);
      break;
    case 2:
      var value = /** @type {!proto.artifact.OeControlTestDetermination} */ (reader.readEnum());
      msg.setDetermination(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReasoning(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecommendedActions(value);
      break;
    case 5:
      var value = new proto.artifact.OeControlTestCitation;
      reader.readMessage(value,proto.artifact.OeControlTestCitation.deserializeBinaryFromReader);
      msg.addCitations(value);
      break;
    case 6:
      var value = new proto.artifact.OeControlTestGaps;
      reader.readMessage(value,proto.artifact.OeControlTestGaps.deserializeBinaryFromReader);
      msg.addGaps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.OeControlTestResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.OeControlTestResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.OeControlTestResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.OeControlTestResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestString();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDetermination();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReasoning();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRecommendedActions();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.artifact.OeControlTestCitation.serializeBinaryToWriter
    );
  }
  f = message.getGapsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.artifact.OeControlTestGaps.serializeBinaryToWriter
    );
  }
};


/**
 * optional string test_string = 1;
 * @return {string}
 */
proto.artifact.OeControlTestResult.prototype.getTestString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestResult} returns this
 */
proto.artifact.OeControlTestResult.prototype.setTestString = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional OeControlTestDetermination determination = 2;
 * @return {!proto.artifact.OeControlTestDetermination}
 */
proto.artifact.OeControlTestResult.prototype.getDetermination = function() {
  return /** @type {!proto.artifact.OeControlTestDetermination} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.artifact.OeControlTestDetermination} value
 * @return {!proto.artifact.OeControlTestResult} returns this
 */
proto.artifact.OeControlTestResult.prototype.setDetermination = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string reasoning = 3;
 * @return {string}
 */
proto.artifact.OeControlTestResult.prototype.getReasoning = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestResult} returns this
 */
proto.artifact.OeControlTestResult.prototype.setReasoning = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string recommended_actions = 4;
 * @return {string}
 */
proto.artifact.OeControlTestResult.prototype.getRecommendedActions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlTestResult} returns this
 */
proto.artifact.OeControlTestResult.prototype.setRecommendedActions = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated OeControlTestCitation citations = 5;
 * @return {!Array<!proto.artifact.OeControlTestCitation>}
 */
proto.artifact.OeControlTestResult.prototype.getCitationsList = function() {
  return /** @type{!Array<!proto.artifact.OeControlTestCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.OeControlTestCitation, 5));
};


/**
 * @param {!Array<!proto.artifact.OeControlTestCitation>} value
 * @return {!proto.artifact.OeControlTestResult} returns this
*/
proto.artifact.OeControlTestResult.prototype.setCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.artifact.OeControlTestCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.OeControlTestCitation}
 */
proto.artifact.OeControlTestResult.prototype.addCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.artifact.OeControlTestCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.OeControlTestResult} returns this
 */
proto.artifact.OeControlTestResult.prototype.clearCitationsList = function() {
  return this.setCitationsList([]);
};


/**
 * repeated OeControlTestGaps gaps = 6;
 * @return {!Array<!proto.artifact.OeControlTestGaps>}
 */
proto.artifact.OeControlTestResult.prototype.getGapsList = function() {
  return /** @type{!Array<!proto.artifact.OeControlTestGaps>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.OeControlTestGaps, 6));
};


/**
 * @param {!Array<!proto.artifact.OeControlTestGaps>} value
 * @return {!proto.artifact.OeControlTestResult} returns this
*/
proto.artifact.OeControlTestResult.prototype.setGapsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.artifact.OeControlTestGaps=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.OeControlTestGaps}
 */
proto.artifact.OeControlTestResult.prototype.addGaps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.artifact.OeControlTestGaps, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.OeControlTestResult} returns this
 */
proto.artifact.OeControlTestResult.prototype.clearGapsList = function() {
  return this.setGapsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.OeControlGap.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.OeControlGap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.OeControlGap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.OeControlGap.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    remediation: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.OeControlGap}
 */
proto.artifact.OeControlGap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.OeControlGap;
  return proto.artifact.OeControlGap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.OeControlGap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.OeControlGap}
 */
proto.artifact.OeControlGap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.artifact.GapType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemediation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.OeControlGap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.OeControlGap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.OeControlGap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.OeControlGap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRemediation();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional GapType type = 1;
 * @return {!proto.artifact.GapType}
 */
proto.artifact.OeControlGap.prototype.getType = function() {
  return /** @type {!proto.artifact.GapType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.artifact.GapType} value
 * @return {!proto.artifact.OeControlGap} returns this
 */
proto.artifact.OeControlGap.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.artifact.OeControlGap.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlGap} returns this
 */
proto.artifact.OeControlGap.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string remediation = 3;
 * @return {string}
 */
proto.artifact.OeControlGap.prototype.getRemediation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlGap} returns this
 */
proto.artifact.OeControlGap.prototype.setRemediation = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.OeControlResultsArtifact.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.OeControlResultsArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.OeControlResultsArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.OeControlResultsArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.OeControlResultsArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    controlName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    determination: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    reasoning: jspb.Message.getFieldWithDefault(msg, 4, ""),
    gapsList: jspb.Message.toObjectList(msg.getGapsList(),
    proto.artifact.OeControlGap.toObject, includeInstance),
    oeControlTestCitationsList: jspb.Message.toObjectList(msg.getOeControlTestCitationsList(),
    proto.artifact.OeControlTestResult.toObject, includeInstance),
    auditRunId: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.OeControlResultsArtifact}
 */
proto.artifact.OeControlResultsArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.OeControlResultsArtifact;
  return proto.artifact.OeControlResultsArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.OeControlResultsArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.OeControlResultsArtifact}
 */
proto.artifact.OeControlResultsArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDetermination(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReasoning(value);
      break;
    case 5:
      var value = new proto.artifact.OeControlGap;
      reader.readMessage(value,proto.artifact.OeControlGap.deserializeBinaryFromReader);
      msg.addGaps(value);
      break;
    case 6:
      var value = new proto.artifact.OeControlTestResult;
      reader.readMessage(value,proto.artifact.OeControlTestResult.deserializeBinaryFromReader);
      msg.addOeControlTestCitations(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditRunId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.OeControlResultsArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.OeControlResultsArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.OeControlResultsArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.OeControlResultsArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getControlName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDetermination();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getReasoning();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGapsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.artifact.OeControlGap.serializeBinaryToWriter
    );
  }
  f = message.getOeControlTestCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.artifact.OeControlTestResult.serializeBinaryToWriter
    );
  }
  f = message.getAuditRunId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string control_id = 1;
 * @return {string}
 */
proto.artifact.OeControlResultsArtifact.prototype.getControlId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlResultsArtifact} returns this
 */
proto.artifact.OeControlResultsArtifact.prototype.setControlId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string control_name = 2;
 * @return {string}
 */
proto.artifact.OeControlResultsArtifact.prototype.getControlName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlResultsArtifact} returns this
 */
proto.artifact.OeControlResultsArtifact.prototype.setControlName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool determination = 3;
 * @return {boolean}
 */
proto.artifact.OeControlResultsArtifact.prototype.getDetermination = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.OeControlResultsArtifact} returns this
 */
proto.artifact.OeControlResultsArtifact.prototype.setDetermination = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string reasoning = 4;
 * @return {string}
 */
proto.artifact.OeControlResultsArtifact.prototype.getReasoning = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlResultsArtifact} returns this
 */
proto.artifact.OeControlResultsArtifact.prototype.setReasoning = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated OeControlGap gaps = 5;
 * @return {!Array<!proto.artifact.OeControlGap>}
 */
proto.artifact.OeControlResultsArtifact.prototype.getGapsList = function() {
  return /** @type{!Array<!proto.artifact.OeControlGap>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.OeControlGap, 5));
};


/**
 * @param {!Array<!proto.artifact.OeControlGap>} value
 * @return {!proto.artifact.OeControlResultsArtifact} returns this
*/
proto.artifact.OeControlResultsArtifact.prototype.setGapsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.artifact.OeControlGap=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.OeControlGap}
 */
proto.artifact.OeControlResultsArtifact.prototype.addGaps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.artifact.OeControlGap, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.OeControlResultsArtifact} returns this
 */
proto.artifact.OeControlResultsArtifact.prototype.clearGapsList = function() {
  return this.setGapsList([]);
};


/**
 * repeated OeControlTestResult oe_control_test_citations = 6;
 * @return {!Array<!proto.artifact.OeControlTestResult>}
 */
proto.artifact.OeControlResultsArtifact.prototype.getOeControlTestCitationsList = function() {
  return /** @type{!Array<!proto.artifact.OeControlTestResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.OeControlTestResult, 6));
};


/**
 * @param {!Array<!proto.artifact.OeControlTestResult>} value
 * @return {!proto.artifact.OeControlResultsArtifact} returns this
*/
proto.artifact.OeControlResultsArtifact.prototype.setOeControlTestCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.artifact.OeControlTestResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.OeControlTestResult}
 */
proto.artifact.OeControlResultsArtifact.prototype.addOeControlTestCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.artifact.OeControlTestResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.OeControlResultsArtifact} returns this
 */
proto.artifact.OeControlResultsArtifact.prototype.clearOeControlTestCitationsList = function() {
  return this.setOeControlTestCitationsList([]);
};


/**
 * optional string audit_run_id = 7;
 * @return {string}
 */
proto.artifact.OeControlResultsArtifact.prototype.getAuditRunId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.OeControlResultsArtifact} returns this
 */
proto.artifact.OeControlResultsArtifact.prototype.setAuditRunId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.PlaybookArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.PlaybookArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.PlaybookArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.PlaybookArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbookId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.PlaybookArtifact}
 */
proto.artifact.PlaybookArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.PlaybookArtifact;
  return proto.artifact.PlaybookArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.PlaybookArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.PlaybookArtifact}
 */
proto.artifact.PlaybookArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaybookId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.PlaybookArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.PlaybookArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.PlaybookArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.PlaybookArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybookId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string playbook_id = 1;
 * @return {string}
 */
proto.artifact.PlaybookArtifact.prototype.getPlaybookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.PlaybookArtifact} returns this
 */
proto.artifact.PlaybookArtifact.prototype.setPlaybookId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.ParamInputOption.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.ParamInputOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.ParamInputOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.ParamInputOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    modelId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    selected: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    isBroken: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.ParamInputOption}
 */
proto.artifact.ParamInputOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.ParamInputOption;
  return proto.artifact.ParamInputOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.ParamInputOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.ParamInputOption}
 */
proto.artifact.ParamInputOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelected(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBroken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.ParamInputOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.ParamInputOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.ParamInputOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.ParamInputOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getModelId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSelected();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getIsBroken();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.artifact.ParamInputOption.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.ParamInputOption} returns this
 */
proto.artifact.ParamInputOption.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string model_id = 2;
 * @return {string}
 */
proto.artifact.ParamInputOption.prototype.getModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.ParamInputOption} returns this
 */
proto.artifact.ParamInputOption.prototype.setModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.artifact.ParamInputOption.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.ParamInputOption} returns this
 */
proto.artifact.ParamInputOption.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.artifact.ParamInputOption.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.ParamInputOption} returns this
 */
proto.artifact.ParamInputOption.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool selected = 5;
 * @return {boolean}
 */
proto.artifact.ParamInputOption.prototype.getSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.ParamInputOption} returns this
 */
proto.artifact.ParamInputOption.prototype.setSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool is_broken = 6;
 * @return {boolean}
 */
proto.artifact.ParamInputOption.prototype.getIsBroken = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.ParamInputOption} returns this
 */
proto.artifact.ParamInputOption.prototype.setIsBroken = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.artifact.PlaybookParamInputArtifact.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.PlaybookParamInputArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.PlaybookParamInputArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.PlaybookParamInputArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.PlaybookParamInputArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    paramName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paramDescription: jspb.Message.getFieldWithDefault(msg, 2, ""),
    parameterType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    allowMultipleValues: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.artifact.ParamInputOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.PlaybookParamInputArtifact}
 */
proto.artifact.PlaybookParamInputArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.PlaybookParamInputArtifact;
  return proto.artifact.PlaybookParamInputArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.PlaybookParamInputArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.PlaybookParamInputArtifact}
 */
proto.artifact.PlaybookParamInputArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParamName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParamDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setParameterType(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowMultipleValues(value);
      break;
    case 5:
      var value = new proto.artifact.ParamInputOption;
      reader.readMessage(value,proto.artifact.ParamInputOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.PlaybookParamInputArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.PlaybookParamInputArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.PlaybookParamInputArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.PlaybookParamInputArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParamName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getParamDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParameterType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAllowMultipleValues();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.artifact.ParamInputOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional string param_name = 1;
 * @return {string}
 */
proto.artifact.PlaybookParamInputArtifact.prototype.getParamName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.PlaybookParamInputArtifact} returns this
 */
proto.artifact.PlaybookParamInputArtifact.prototype.setParamName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string param_description = 2;
 * @return {string}
 */
proto.artifact.PlaybookParamInputArtifact.prototype.getParamDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.PlaybookParamInputArtifact} returns this
 */
proto.artifact.PlaybookParamInputArtifact.prototype.setParamDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string parameter_type = 3;
 * @return {string}
 */
proto.artifact.PlaybookParamInputArtifact.prototype.getParameterType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.PlaybookParamInputArtifact} returns this
 */
proto.artifact.PlaybookParamInputArtifact.prototype.setParameterType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool allow_multiple_values = 4;
 * @return {boolean}
 */
proto.artifact.PlaybookParamInputArtifact.prototype.getAllowMultipleValues = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.artifact.PlaybookParamInputArtifact} returns this
 */
proto.artifact.PlaybookParamInputArtifact.prototype.setAllowMultipleValues = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * repeated ParamInputOption options = 5;
 * @return {!Array<!proto.artifact.ParamInputOption>}
 */
proto.artifact.PlaybookParamInputArtifact.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.artifact.ParamInputOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.artifact.ParamInputOption, 5));
};


/**
 * @param {!Array<!proto.artifact.ParamInputOption>} value
 * @return {!proto.artifact.PlaybookParamInputArtifact} returns this
*/
proto.artifact.PlaybookParamInputArtifact.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.artifact.ParamInputOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.artifact.ParamInputOption}
 */
proto.artifact.PlaybookParamInputArtifact.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.artifact.ParamInputOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.artifact.PlaybookParamInputArtifact} returns this
 */
proto.artifact.PlaybookParamInputArtifact.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.artifact.Artifact.oneofGroups_ = [[5,6,7,8,9,10,11,12,17,18,19,21,22,23,24,25]];

/**
 * @enum {number}
 */
proto.artifact.Artifact.ArtifactDataCase = {
  ARTIFACT_DATA_NOT_SET: 0,
  MIME_ARTIFACT: 5,
  POLICIES_ARTIFACT: 6,
  FRAMEWORK_DOC_ARTIFACT: 7,
  SELECTION_ARTIFACT: 8,
  FRAMEWORK_SECTION_ARTIFACT: 9,
  FRAMEWORK_QUESTIONNAIRE_ARTIFACT: 10,
  COST_ESTIMATE_ARTIFACT: 11,
  REPORT_ARTIFACT: 12,
  CONTROLS_ARTIFACT: 17,
  TEST_TABLE_ARTIFACT: 18,
  CROSS_REFERENCED_DATA_ARTIFACT: 19,
  PLAYBOOK_ARTIFACT: 21,
  OE_CONTROL_RESULTS_ARTIFACT: 22,
  PLAYBOOK_PARAM_INPUT_ARTIFACT: 23,
  SAMPLED_EVIDENCE_ARTIFACT: 24,
  FILTERED_EVIDENCE_ARTIFACT: 25
};

/**
 * @return {proto.artifact.Artifact.ArtifactDataCase}
 */
proto.artifact.Artifact.prototype.getArtifactDataCase = function() {
  return /** @type {proto.artifact.Artifact.ArtifactDataCase} */(jspb.Message.computeOneofCase(this, proto.artifact.Artifact.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.artifact.Artifact.prototype.toObject = function(opt_includeInstance) {
  return proto.artifact.Artifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.artifact.Artifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Artifact.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    chatId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    agentName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 13, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 14, 0),
    description: jspb.Message.getFieldWithDefault(msg, 15, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 16, ""),
    mimeArtifact: (f = msg.getMimeArtifact()) && proto.artifact.MimeArtifact.toObject(includeInstance, f),
    policiesArtifact: (f = msg.getPoliciesArtifact()) && proto.artifact.PoliciesArtifact.toObject(includeInstance, f),
    frameworkDocArtifact: (f = msg.getFrameworkDocArtifact()) && proto.artifact.FrameworkDocArtifact.toObject(includeInstance, f),
    selectionArtifact: (f = msg.getSelectionArtifact()) && proto.artifact.SelectionArtifact.toObject(includeInstance, f),
    frameworkSectionArtifact: (f = msg.getFrameworkSectionArtifact()) && proto.artifact.FrameworkSectionArtifact.toObject(includeInstance, f),
    frameworkQuestionnaireArtifact: (f = msg.getFrameworkQuestionnaireArtifact()) && proto.artifact.FrameworkQuestionnaireArtifact.toObject(includeInstance, f),
    costEstimateArtifact: (f = msg.getCostEstimateArtifact()) && proto.artifact.CostEstimateArtifact.toObject(includeInstance, f),
    reportArtifact: (f = msg.getReportArtifact()) && proto.artifact.ReportArtifact.toObject(includeInstance, f),
    controlsArtifact: (f = msg.getControlsArtifact()) && proto.artifact.ControlsArtifact.toObject(includeInstance, f),
    testTableArtifact: (f = msg.getTestTableArtifact()) && proto.artifact.TestTableArtifact.toObject(includeInstance, f),
    crossReferencedDataArtifact: (f = msg.getCrossReferencedDataArtifact()) && proto.artifact.CrossReferencedDataArtifact.toObject(includeInstance, f),
    playbookArtifact: (f = msg.getPlaybookArtifact()) && proto.artifact.PlaybookArtifact.toObject(includeInstance, f),
    oeControlResultsArtifact: (f = msg.getOeControlResultsArtifact()) && proto.artifact.OeControlResultsArtifact.toObject(includeInstance, f),
    playbookParamInputArtifact: (f = msg.getPlaybookParamInputArtifact()) && proto.artifact.PlaybookParamInputArtifact.toObject(includeInstance, f),
    sampledEvidenceArtifact: (f = msg.getSampledEvidenceArtifact()) && proto.artifact.SampledEvidenceArtifact.toObject(includeInstance, f),
    filteredEvidenceArtifact: (f = msg.getFilteredEvidenceArtifact()) && proto.artifact.FilteredEvidenceArtifact.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.artifact.Artifact}
 */
proto.artifact.Artifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.artifact.Artifact;
  return proto.artifact.Artifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.artifact.Artifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.artifact.Artifact}
 */
proto.artifact.Artifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.artifact.ArtifactType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgentName(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 5:
      var value = new proto.artifact.MimeArtifact;
      reader.readMessage(value,proto.artifact.MimeArtifact.deserializeBinaryFromReader);
      msg.setMimeArtifact(value);
      break;
    case 6:
      var value = new proto.artifact.PoliciesArtifact;
      reader.readMessage(value,proto.artifact.PoliciesArtifact.deserializeBinaryFromReader);
      msg.setPoliciesArtifact(value);
      break;
    case 7:
      var value = new proto.artifact.FrameworkDocArtifact;
      reader.readMessage(value,proto.artifact.FrameworkDocArtifact.deserializeBinaryFromReader);
      msg.setFrameworkDocArtifact(value);
      break;
    case 8:
      var value = new proto.artifact.SelectionArtifact;
      reader.readMessage(value,proto.artifact.SelectionArtifact.deserializeBinaryFromReader);
      msg.setSelectionArtifact(value);
      break;
    case 9:
      var value = new proto.artifact.FrameworkSectionArtifact;
      reader.readMessage(value,proto.artifact.FrameworkSectionArtifact.deserializeBinaryFromReader);
      msg.setFrameworkSectionArtifact(value);
      break;
    case 10:
      var value = new proto.artifact.FrameworkQuestionnaireArtifact;
      reader.readMessage(value,proto.artifact.FrameworkQuestionnaireArtifact.deserializeBinaryFromReader);
      msg.setFrameworkQuestionnaireArtifact(value);
      break;
    case 11:
      var value = new proto.artifact.CostEstimateArtifact;
      reader.readMessage(value,proto.artifact.CostEstimateArtifact.deserializeBinaryFromReader);
      msg.setCostEstimateArtifact(value);
      break;
    case 12:
      var value = new proto.artifact.ReportArtifact;
      reader.readMessage(value,proto.artifact.ReportArtifact.deserializeBinaryFromReader);
      msg.setReportArtifact(value);
      break;
    case 17:
      var value = new proto.artifact.ControlsArtifact;
      reader.readMessage(value,proto.artifact.ControlsArtifact.deserializeBinaryFromReader);
      msg.setControlsArtifact(value);
      break;
    case 18:
      var value = new proto.artifact.TestTableArtifact;
      reader.readMessage(value,proto.artifact.TestTableArtifact.deserializeBinaryFromReader);
      msg.setTestTableArtifact(value);
      break;
    case 19:
      var value = new proto.artifact.CrossReferencedDataArtifact;
      reader.readMessage(value,proto.artifact.CrossReferencedDataArtifact.deserializeBinaryFromReader);
      msg.setCrossReferencedDataArtifact(value);
      break;
    case 21:
      var value = new proto.artifact.PlaybookArtifact;
      reader.readMessage(value,proto.artifact.PlaybookArtifact.deserializeBinaryFromReader);
      msg.setPlaybookArtifact(value);
      break;
    case 22:
      var value = new proto.artifact.OeControlResultsArtifact;
      reader.readMessage(value,proto.artifact.OeControlResultsArtifact.deserializeBinaryFromReader);
      msg.setOeControlResultsArtifact(value);
      break;
    case 23:
      var value = new proto.artifact.PlaybookParamInputArtifact;
      reader.readMessage(value,proto.artifact.PlaybookParamInputArtifact.deserializeBinaryFromReader);
      msg.setPlaybookParamInputArtifact(value);
      break;
    case 24:
      var value = new proto.artifact.SampledEvidenceArtifact;
      reader.readMessage(value,proto.artifact.SampledEvidenceArtifact.deserializeBinaryFromReader);
      msg.setSampledEvidenceArtifact(value);
      break;
    case 25:
      var value = new proto.artifact.FilteredEvidenceArtifact;
      reader.readMessage(value,proto.artifact.FilteredEvidenceArtifact.deserializeBinaryFromReader);
      msg.setFilteredEvidenceArtifact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.artifact.Artifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.artifact.Artifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.artifact.Artifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.artifact.Artifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAgentName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getMimeArtifact();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.artifact.MimeArtifact.serializeBinaryToWriter
    );
  }
  f = message.getPoliciesArtifact();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.artifact.PoliciesArtifact.serializeBinaryToWriter
    );
  }
  f = message.getFrameworkDocArtifact();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.artifact.FrameworkDocArtifact.serializeBinaryToWriter
    );
  }
  f = message.getSelectionArtifact();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.artifact.SelectionArtifact.serializeBinaryToWriter
    );
  }
  f = message.getFrameworkSectionArtifact();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.artifact.FrameworkSectionArtifact.serializeBinaryToWriter
    );
  }
  f = message.getFrameworkQuestionnaireArtifact();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.artifact.FrameworkQuestionnaireArtifact.serializeBinaryToWriter
    );
  }
  f = message.getCostEstimateArtifact();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.artifact.CostEstimateArtifact.serializeBinaryToWriter
    );
  }
  f = message.getReportArtifact();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.artifact.ReportArtifact.serializeBinaryToWriter
    );
  }
  f = message.getControlsArtifact();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.artifact.ControlsArtifact.serializeBinaryToWriter
    );
  }
  f = message.getTestTableArtifact();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.artifact.TestTableArtifact.serializeBinaryToWriter
    );
  }
  f = message.getCrossReferencedDataArtifact();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.artifact.CrossReferencedDataArtifact.serializeBinaryToWriter
    );
  }
  f = message.getPlaybookArtifact();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.artifact.PlaybookArtifact.serializeBinaryToWriter
    );
  }
  f = message.getOeControlResultsArtifact();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.artifact.OeControlResultsArtifact.serializeBinaryToWriter
    );
  }
  f = message.getPlaybookParamInputArtifact();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.artifact.PlaybookParamInputArtifact.serializeBinaryToWriter
    );
  }
  f = message.getSampledEvidenceArtifact();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.artifact.SampledEvidenceArtifact.serializeBinaryToWriter
    );
  }
  f = message.getFilteredEvidenceArtifact();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      proto.artifact.FilteredEvidenceArtifact.serializeBinaryToWriter
    );
  }
};


/**
 * optional ArtifactType type = 1;
 * @return {!proto.artifact.ArtifactType}
 */
proto.artifact.Artifact.prototype.getType = function() {
  return /** @type {!proto.artifact.ArtifactType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.artifact.ArtifactType} value
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.artifact.Artifact.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string chat_id = 3;
 * @return {string}
 */
proto.artifact.Artifact.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string agent_name = 4;
 * @return {string}
 */
proto.artifact.Artifact.prototype.getAgentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.setAgentName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 created_at = 13;
 * @return {number}
 */
proto.artifact.Artifact.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 updated_at = 14;
 * @return {number}
 */
proto.artifact.Artifact.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string description = 15;
 * @return {string}
 */
proto.artifact.Artifact.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string content_id = 16;
 * @return {string}
 */
proto.artifact.Artifact.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional MimeArtifact mime_artifact = 5;
 * @return {?proto.artifact.MimeArtifact}
 */
proto.artifact.Artifact.prototype.getMimeArtifact = function() {
  return /** @type{?proto.artifact.MimeArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.MimeArtifact, 5));
};


/**
 * @param {?proto.artifact.MimeArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setMimeArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearMimeArtifact = function() {
  return this.setMimeArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasMimeArtifact = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PoliciesArtifact policies_artifact = 6;
 * @return {?proto.artifact.PoliciesArtifact}
 */
proto.artifact.Artifact.prototype.getPoliciesArtifact = function() {
  return /** @type{?proto.artifact.PoliciesArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.PoliciesArtifact, 6));
};


/**
 * @param {?proto.artifact.PoliciesArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setPoliciesArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearPoliciesArtifact = function() {
  return this.setPoliciesArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasPoliciesArtifact = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional FrameworkDocArtifact framework_doc_artifact = 7;
 * @return {?proto.artifact.FrameworkDocArtifact}
 */
proto.artifact.Artifact.prototype.getFrameworkDocArtifact = function() {
  return /** @type{?proto.artifact.FrameworkDocArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.FrameworkDocArtifact, 7));
};


/**
 * @param {?proto.artifact.FrameworkDocArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setFrameworkDocArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearFrameworkDocArtifact = function() {
  return this.setFrameworkDocArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasFrameworkDocArtifact = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SelectionArtifact selection_artifact = 8;
 * @return {?proto.artifact.SelectionArtifact}
 */
proto.artifact.Artifact.prototype.getSelectionArtifact = function() {
  return /** @type{?proto.artifact.SelectionArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.SelectionArtifact, 8));
};


/**
 * @param {?proto.artifact.SelectionArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setSelectionArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearSelectionArtifact = function() {
  return this.setSelectionArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasSelectionArtifact = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional FrameworkSectionArtifact framework_section_artifact = 9;
 * @return {?proto.artifact.FrameworkSectionArtifact}
 */
proto.artifact.Artifact.prototype.getFrameworkSectionArtifact = function() {
  return /** @type{?proto.artifact.FrameworkSectionArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.FrameworkSectionArtifact, 9));
};


/**
 * @param {?proto.artifact.FrameworkSectionArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setFrameworkSectionArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearFrameworkSectionArtifact = function() {
  return this.setFrameworkSectionArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasFrameworkSectionArtifact = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional FrameworkQuestionnaireArtifact framework_questionnaire_artifact = 10;
 * @return {?proto.artifact.FrameworkQuestionnaireArtifact}
 */
proto.artifact.Artifact.prototype.getFrameworkQuestionnaireArtifact = function() {
  return /** @type{?proto.artifact.FrameworkQuestionnaireArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.FrameworkQuestionnaireArtifact, 10));
};


/**
 * @param {?proto.artifact.FrameworkQuestionnaireArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setFrameworkQuestionnaireArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearFrameworkQuestionnaireArtifact = function() {
  return this.setFrameworkQuestionnaireArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasFrameworkQuestionnaireArtifact = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional CostEstimateArtifact cost_estimate_artifact = 11;
 * @return {?proto.artifact.CostEstimateArtifact}
 */
proto.artifact.Artifact.prototype.getCostEstimateArtifact = function() {
  return /** @type{?proto.artifact.CostEstimateArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.CostEstimateArtifact, 11));
};


/**
 * @param {?proto.artifact.CostEstimateArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setCostEstimateArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearCostEstimateArtifact = function() {
  return this.setCostEstimateArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasCostEstimateArtifact = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional ReportArtifact report_artifact = 12;
 * @return {?proto.artifact.ReportArtifact}
 */
proto.artifact.Artifact.prototype.getReportArtifact = function() {
  return /** @type{?proto.artifact.ReportArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.ReportArtifact, 12));
};


/**
 * @param {?proto.artifact.ReportArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setReportArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearReportArtifact = function() {
  return this.setReportArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasReportArtifact = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional ControlsArtifact controls_artifact = 17;
 * @return {?proto.artifact.ControlsArtifact}
 */
proto.artifact.Artifact.prototype.getControlsArtifact = function() {
  return /** @type{?proto.artifact.ControlsArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.ControlsArtifact, 17));
};


/**
 * @param {?proto.artifact.ControlsArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setControlsArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 17, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearControlsArtifact = function() {
  return this.setControlsArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasControlsArtifact = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional TestTableArtifact test_table_artifact = 18;
 * @return {?proto.artifact.TestTableArtifact}
 */
proto.artifact.Artifact.prototype.getTestTableArtifact = function() {
  return /** @type{?proto.artifact.TestTableArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.TestTableArtifact, 18));
};


/**
 * @param {?proto.artifact.TestTableArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setTestTableArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 18, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearTestTableArtifact = function() {
  return this.setTestTableArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasTestTableArtifact = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional CrossReferencedDataArtifact cross_referenced_data_artifact = 19;
 * @return {?proto.artifact.CrossReferencedDataArtifact}
 */
proto.artifact.Artifact.prototype.getCrossReferencedDataArtifact = function() {
  return /** @type{?proto.artifact.CrossReferencedDataArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.CrossReferencedDataArtifact, 19));
};


/**
 * @param {?proto.artifact.CrossReferencedDataArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setCrossReferencedDataArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 19, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearCrossReferencedDataArtifact = function() {
  return this.setCrossReferencedDataArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasCrossReferencedDataArtifact = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional PlaybookArtifact playbook_artifact = 21;
 * @return {?proto.artifact.PlaybookArtifact}
 */
proto.artifact.Artifact.prototype.getPlaybookArtifact = function() {
  return /** @type{?proto.artifact.PlaybookArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.PlaybookArtifact, 21));
};


/**
 * @param {?proto.artifact.PlaybookArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setPlaybookArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 21, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearPlaybookArtifact = function() {
  return this.setPlaybookArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasPlaybookArtifact = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional OeControlResultsArtifact oe_control_results_artifact = 22;
 * @return {?proto.artifact.OeControlResultsArtifact}
 */
proto.artifact.Artifact.prototype.getOeControlResultsArtifact = function() {
  return /** @type{?proto.artifact.OeControlResultsArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.OeControlResultsArtifact, 22));
};


/**
 * @param {?proto.artifact.OeControlResultsArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setOeControlResultsArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 22, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearOeControlResultsArtifact = function() {
  return this.setOeControlResultsArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasOeControlResultsArtifact = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional PlaybookParamInputArtifact playbook_param_input_artifact = 23;
 * @return {?proto.artifact.PlaybookParamInputArtifact}
 */
proto.artifact.Artifact.prototype.getPlaybookParamInputArtifact = function() {
  return /** @type{?proto.artifact.PlaybookParamInputArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.PlaybookParamInputArtifact, 23));
};


/**
 * @param {?proto.artifact.PlaybookParamInputArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setPlaybookParamInputArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 23, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearPlaybookParamInputArtifact = function() {
  return this.setPlaybookParamInputArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasPlaybookParamInputArtifact = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional SampledEvidenceArtifact sampled_evidence_artifact = 24;
 * @return {?proto.artifact.SampledEvidenceArtifact}
 */
proto.artifact.Artifact.prototype.getSampledEvidenceArtifact = function() {
  return /** @type{?proto.artifact.SampledEvidenceArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.SampledEvidenceArtifact, 24));
};


/**
 * @param {?proto.artifact.SampledEvidenceArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setSampledEvidenceArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 24, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearSampledEvidenceArtifact = function() {
  return this.setSampledEvidenceArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasSampledEvidenceArtifact = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional FilteredEvidenceArtifact filtered_evidence_artifact = 25;
 * @return {?proto.artifact.FilteredEvidenceArtifact}
 */
proto.artifact.Artifact.prototype.getFilteredEvidenceArtifact = function() {
  return /** @type{?proto.artifact.FilteredEvidenceArtifact} */ (
    jspb.Message.getWrapperField(this, proto.artifact.FilteredEvidenceArtifact, 25));
};


/**
 * @param {?proto.artifact.FilteredEvidenceArtifact|undefined} value
 * @return {!proto.artifact.Artifact} returns this
*/
proto.artifact.Artifact.prototype.setFilteredEvidenceArtifact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 25, proto.artifact.Artifact.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.artifact.Artifact} returns this
 */
proto.artifact.Artifact.prototype.clearFilteredEvidenceArtifact = function() {
  return this.setFilteredEvidenceArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.artifact.Artifact.prototype.hasFilteredEvidenceArtifact = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * @enum {number}
 */
proto.artifact.ArtifactType = {
  ARTIFACT_UNSPECIFIED: 0,
  ARTIFACT_MIME: 1,
  ARTIFACT_POLICIES: 2,
  ARTIFACT_FRAMEWORK_DOC: 3,
  ARTIFACT_SELECTION: 4,
  ARTIFACT_FRAMEWORK_SECTION: 5,
  ARTIFACT_FRAMEWORK_QUESTIONNAIRE: 6,
  ARTIFACT_COST_ESTIMATE: 7,
  ARTIFACT_REPORT: 8,
  ARTIFACT_CONTROLS: 9,
  ARTIFACT_TEST_TABLE: 10,
  ARTIFACT_CROSS_REFERENCED_DATA: 11,
  ARTIFACT_PLAYBOOK: 13,
  ARTIFACT_OE_CONTROL_RESULTS: 14,
  ARTIFACT_PLAYBOOK_PARAM_INPUT: 15,
  ARTIFACT_SAMPLED_EVIDENCE: 16,
  ARTIFACT_FILTERED_EVIDENCE: 17
};

/**
 * @enum {number}
 */
proto.artifact.ReportType = {
  REPORT_UNSPECIFIED: 0,
  REPORT_PDA: 1,
  REPORT_PLAYBOOK_SUMMARY: 2,
  REPORT_CHAT_SUMMARY: 3
};

/**
 * @enum {number}
 */
proto.artifact.OeControlTestCitationType = {
  UNKNOWN: 0,
  EVIDENCE: 1,
  ARTIFACT: 2,
  CONTEXT: 3
};

/**
 * @enum {number}
 */
proto.artifact.OeControlTestDetermination = {
  INCOMPLETE: 0,
  PASS: 1,
  FAIL: 2
};

/**
 * @enum {number}
 */
proto.artifact.GapType = {
  MISSING_EVIDENCE: 0,
  INCOMPLETE_EVIDENCE: 1,
  INCONSISTENT_EVIDENCE: 2,
  OUTDATED_EVIDENCE: 3
};

goog.object.extend(exports, proto.artifact);
